import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DuePaymentModal from "./DuePaymentModal"; // Import the modal component
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ChangePackage from '../MemberList/Components/ChangePackage';
import ChangePackagePt from '../MemberList/Components/ChangePackagePt.jsx';
import RepeatIcon from "@mui/icons-material/Repeat";
import AddIcon from '@mui/icons-material/Add';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { TimePicker } from "@mui/x-date-pickers";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import Drawer from "@mui/material/Drawer";
import { Avatar, Divider, ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useMemo } from "react";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { useEffect, useRef } from "react";
import {
  Card,
  Button,
  Grid,
  Tabs,
  Tab,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Chip,
  Stack,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Menu from "@mui/material/Menu";
import PaymentIcon from "@mui/icons-material/Payment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import PaymentHistory from "./PaymentHistory";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import RenewIcon from "@mui/icons-material/Autorenew"; // Make sure to import the correct renewal icon
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

import {
  retrieveGymMember,
  PtPackageDropdown,
  PtTrainerDropdown,
  PtTrainerSlotTimes,
  PtPackageDropdownvalue,
  TrainerPayment,
  addYearlyPackageIfExpired,
  MembershipPause,
  MembershipResume,
} from "../Apihelper/MemberDashboard";
import {
  getSessionTimeBoundsForPickers,
  hasTrainerEveningSlot,
  hasTrainerMorningSlot,
  rawEveningSlotPresent,
  isPtEndTimeWithinSessionSlot,
  isPtStartTimeWithinSessionSlot,
  trainerSlotAllowedStartSummaryForSession,
  resolveSessionFromSlotString,
} from "../../utils/trainerSlotTime";
import { PtduePaymentClear, YearlyDuePaymentClear } from "../Apihelper/DueUserApi";
import {
  PackageadmissionDropdown,
  PackageAdmissionDropdownvalue,
} from "../Apihelper/AdmissionValueApi.js";
import {
  createNewMember,
  AutoMembershipNumber,
  PackageDropdownafteradmission,
  PackageDropdownvalueafteradmission,
} from "../Apihelper/MemberApiHelpr";
import {
  MembeRepeatPackage,
  MembeRenwalPackage,
  TrainerChange,
} from "../Apihelper/ApiHelperPayment";
import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#ffffff',
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
}));

const InfoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
}));

const CloseButton = styled(IconButton)({
  color: '#ffffff',
});

const DetailDialog = ({ open, handleClose, data }) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <StyledDialogTitle>
        Personal Details
        <CloseButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon />
        </CloseButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Avatar
            src={(data.image && data.image !== 'null') ? data.image : ''}
            alt="Profile"
            sx={{ width: 80, height: 80, mr: 2 }}
          />
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {data.name}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <InfoBox>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Phone:
          </Typography>
          <Typography variant="body2">{data.phone}</Typography>
        </InfoBox>
        <InfoBox>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Email:
          </Typography>
          <Typography variant="body2">{data.email}</Typography>
        </InfoBox>
        <InfoBox>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Address:
          </Typography>
          <Typography variant="body2">{data.address}</Typography>
        </InfoBox>
        <InfoBox>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Dob:
          </Typography>
          <Typography variant="body2">{data.dob}</Typography>
        </InfoBox>
        <InfoBox>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Alternate phone:
          </Typography>
          <Typography variant="body2">{data.alternate_phone}</Typography>
        </InfoBox>
        {/* Add more fields as needed */}
      </StyledDialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const drawerWidth = 292;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

function MemberDetails(props) {
  const { colors: appColors } = useAppTheme();

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [Dropdowndata, setDropdowndata] = useState([]); // Default to 'success'
  const { window1 } = props;
  const conversation_id = location.state?.id;

  const dateRef = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [renwalloading, setrenwalLoading] = useState(false);
  const [addPTPSubmitting, setAddPTPSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const [dialogData, setDialogData] = useState({});
  const [fetchdatarow, setetchdatarow] = useState([]);
  const [paymentrow, setpaymentrow] = useState([]);
  const [ptpaymentrow, setptpaymentrow] = useState([]);
  const [yearlymembership, setyearlymembership] = useState([]);
  const [age, setAge] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [packageamount, setpackageamount] = useState(""); // Default to 'success'
 
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [value, setValue] = React.useState("");
  const [resumeDate, setResumeDate] = useState(null); // Define resumeDate state variable
  const [dialogOpen, setDialogOpen] = useState(false);
  const [opendue, setOpendue] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [opendueYearly, setOpendueYearly] = useState(false);
  const [selectedYearlyPayment, setSelectedYearlyPayment] = useState(null);
  const [useopen, setuseopen] = useState(false);
  const [confirmRenewOpen, setConfirmRenewOpen] = useState(false);
  const [confirmRepeatOpen, setConfirmRepeatOpen] = useState(false);
  const [confirmAddPTPOpen, setConfirmAddPTPOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [membershipExpired, setMembershipExpired] = useState(false);
  const [repeatOpen, setRepeatOpen] = useState(false);
  const [repeatEndDatePreview, setRepeatEndDatePreview] = useState(null);
  const [repeatOffer, setRepeatOffer] = useState("");
  const [packageIdrepeat, setPackageIdrepeat] = useState(null); // State to store package ID
  const [repeatModeOfPayment, setRepeatModeOfPayment] = useState(""); // State to store mode of payment
  const [pauseOrResume, setPauseOrResume] = useState(true);
  const [isResumeModal, setIsResumeModal] = useState(false);
  const [isAddPTPModal, setIsAddPTPModal] = useState(false);
  const [addPTPPreviousPayment, setAddPTPPreviousPayment] = useState(null);
  const [isAddYMPModal, setIsAddYMPModal] = useState(false);
  const [isPauseModal, setIsPauseModal] = useState(false);
  const [Dropdowndatamember, setDropdowndatamember] = useState([]);
  const [renewalAmount, setRenewalAmount] = useState('');
  const [renewalType, setRenewalType] = useState('');
  const [Dropdownadmissiondata, setDropdownadmissiondata] = useState([]); // Default to 'success'
  const [Dropdowndatatrainer, setDropdowndatatrainer] = useState([]);
  const [ptTrainerSlotInfo, setPtTrainerSlotInfo] = useState(null);
  const [ptTrainerSlotLoading, setPtTrainerSlotLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);

const [openChangeModal, setOpenChangeModal] = useState(false);
const [openChangeModalpt, setOpenChangeModalpt] = useState(false);
const [selectedPaymentData, setSelectedPaymentData] = useState(null);
const [selectedPaymentDataPt, setSelectedPaymentDataPt] = useState(null);
const handleOpenChangeModal = (paymentData) => {
  setSelectedPaymentData(paymentData);
  setOpenChangeModal(true);
};

const handleCloseChangeModal = () => {
  setOpenChangeModal(false);
  setSelectedPaymentData(null);
};

const handleOpenChangeModalPt = (paymentData) => {
  setSelectedPaymentDataPt(paymentData);
  setOpenChangeModalpt(true);
};

const handleCloseChangeModalpt = () => {
  setOpenChangeModalpt(false);
  setSelectedPaymentDataPt(null);
};



const handleCloseDialogs = () => {
  setIsDialogOpen(false); // Close the dialog
};
  // Function to handle the dialog open and store the package_id (payment.id)
  const repeatHandleOpen = (paymentrow) => {
    const selectedPayment = paymentrow.find((payment) => payment.package_id);
    const membershipExpiredStatus = paymentrow.some((payment) => payment.admission_expired);
  console.log(membershipExpiredStatus);
    if (selectedPayment) {
      setPackageIdrepeat(selectedPayment.package_id);
      setMembershipExpired(membershipExpiredStatus); // Set membership expiration status
      // Repeating keeps the same package + same start_date, so the backend
      // recomputes the exact same end_date the current cycle already has.
      setRepeatEndDatePreview(selectedPayment.end_date || null);
      setRepeatOpen(true);
    } else {
      console.error("Payment not found in paymentrow.");
    }
  };
  
  const handleNavigate = (invoiceNumber, conversationId) => {
    navigate("/invoice", {
      state: {
        invoice_number: invoiceNumber,
        conversation_id: conversation_id,
      },
    });
  };
  
  // Function to handle the dialog open

  // Function to handle the dialog close
const repeatHandleClose = () => {
  setRepeatOpen(false); // close modal

  // reset form data (if applicable)
  setPackageIdrepeat(null); // Store the package_id in state
  setRepeatEndDatePreview(null);
  setRepeatOffer("");
  setRepeatModeOfPayment("");
};

  const [formdueData, setFormdueData] = useState({
    member_id: conversation_id,
    package_id: "",
    total_payble_amount: "",
    payble_amount: "",
    offer: "",
    paying_amount: "",
    mode_of_payment: "",
    date_of_payment: new Date().toISOString().split('T')[0],
    start_date: "",
    end_date: "",
     membershipvalue:"",
           membership:"",
    // Yearly membership is tracked as its own independent payment (own payble/offer/
    // paying/due), never merged into the main package's totals above — this is what
    // creates the separate YearlyPackage record on the backend (renewPackage).
    yearly_payble_amount: "",
    yearly_offer: "",
    yearly_paying_amount: "",
  });

  const fetchDropdownAdmissiondata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageadmissionDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdownadmissiondata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    if (conversation_id) {
      setFormdueData((prevState) => ({
        ...prevState,
        member_id: conversation_id,
      }));
    }
  }, [conversation_id]); // Update when conversation_id is available

  // Open dialog with specific data
  const handlerenwalChange = (data) => {
    // Assuming data is an array, access the first item
    const paymentData = data[0];
    const membershipExpiredStatus = data.some((payment) => payment.admission_expired);
  
    // Set membership expired status
    setMembershipExpired(membershipExpiredStatus);
  
    // Extract end_date and start_date from the paymentData object
    const { end_date, start_date } = paymentData; // Ensure both are part of the data passed
  
    console.log("End Date:", end_date); // Log end_date to the console
    console.log("Start Date:", start_date); // Log start_date to the console
  
    // Safely format start_date
    let formattedStartDate = null;
    if (end_date) {
      const dateParts = end_date.split('-'); // Split the date (if in d-m-y format)
      if (dateParts.length === 3) {
        const [day, month, year] = dateParts;
        const validDate = new Date(`${year}-${month}-${day}`); // Convert to yyyy-mm-dd
        if (!isNaN(validDate.getTime())) {
          formattedStartDate = validDate.toISOString().split('T')[0];
        } else {
          console.error("Invalid start_date:", end_date);
        }
      } else {
        console.error("Invalid start_date format:", end_date);
      }
    }
  
    const currentDateStr = new Date().toISOString().split('T')[0];
    // Update form data with end_date, formatted start_date, and current date of payment
    setFormdueData((prevData) => ({
      ...prevData,
      end_date,
      start_date: formattedStartDate,
      date_of_payment: currentDateStr,
    }));

    // Open the dialog
    setuseopen(true);
  };
  

  // Close dialog
  const handlerenwalclose = () => {
    setuseopen(false); // close modal
    const currentDateStr = new Date().toISOString().split('T')[0];
    setFormdueData({
      member_id: conversation_id,
      package_id: "",
      total_payble_amount: "",
      payble_amount: "",
      offer: "",
      paying_amount: "",
      mode_of_payment: "",
      date_of_payment: currentDateStr,
      start_date: "",
      end_date: "",
      end_date_preview: "",
      membershipvalue: "",
      membership: "",
      yearly_payble_amount: "",
      yearly_offer: "",
      yearly_paying_amount: "",
    });
    setPrevPackageAmount(0);
  };
  
  // Handle input change
  const handleChangerenwal = (e) => {
    const { name, value } = e.target;

    setFormdueData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      // Ensure 'payble_amount' starts as the same as 'total_payble_amount'
      if (!prevData.payble_amount) {
        updatedData.payble_amount = prevData.total_payble_amount;
      }

      // If 'offer' changes, update the payable amount based on the total payable amount and the offer
      if (name === "offer") {
        const updatedPayable = prevData.total_payble_amount - value;
        updatedData.paying_amount = updatedPayable >= 0 ? updatedPayable : 0;
      }

      if (name === "payble_amount") {
        updatedData.payble_amount = prevData.total_payble_amount; // Keep payble_amount same as total_payble_amount
      }
      return updatedData;
    });
  };

  const handlerepeatSubmit = async () => {
    setrenwalLoading(true); // Hide loader when submission finishes
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const numericRepeatOffer = Number(repeatOffer);

      const response = await MembeRepeatPackage(
        userToken,
        userId,
        conversation_id,
        packageIdrepeat,
        repeatModeOfPayment,
        numericRepeatOffer,
        renewalType,
        renewalAmount,
      );

      if (response.code === 200)
        {
        setSnackbarMessage(response.message);
        setSnackbarSeverity("success");
        setOpenToast(true); // Show success Snackbar
        repeatHandleClose(); // Close the modal
        setPackageIdrepeat(null); // Store the package_id in state
        setRepeatOffer("");
        setRepeatModeOfPayment("");
        fetchData();

      } else {
        setSnackbarMessage(
          response.message || "Error occurred while renewing package."
        );
        setSnackbarSeverity("error");
        setOpenToast(true); // Show error Snackbar
      }
    } catch (error) {
      setSnackbarMessage("Failed to rene: " + error.message);
      setSnackbarSeverity("error");
      setOpenToast(true); // Show error Snackbar
    } finally {
      setrenwalLoading(false); // Hide loader when submission finishes
    }

    repeatHandleClose(); // Close the dialog after submission
  };

  const handleSave = () => {
    setConfirmRenewOpen(true);
  };

  const doRenewSave = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setConfirmRenewOpen(false);
    setrenwalLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const response = await MembeRenwalPackage(
        userToken,
        userId,
        conversation_id,
        formdueData
      );

      if (response.code == "200") {
        setSnackbarMessage(response.message);
        setSnackbarSeverity("success");
        setOpenToast(true);
        handlerenwalclose();
        fetchData();
        setFormdueData({
          member_id: conversation_id,
          package_id: "",
          total_payble_amount: "",
           payble_amount: "",
           offer: "",
           paying_amount: "",
           mode_of_payment: "",
           date_of_payment: "",
           start_date: "",
           end_date: "",
            membershipvalue:"",
           membership:"",
           yearly_payble_amount: "",
           yearly_offer: "",
           yearly_paying_amount: "",
        });
      } else {
        setSnackbarMessage(
          response.message || "Error occurred while renewing package."
        );
        setSnackbarSeverity("error");
        setOpenToast(true);
      }
    } catch (error) {
      setSnackbarMessage("Failed to renew package: " + error.message);
      setSnackbarSeverity("error");
      setOpenToast(true);
    } finally {
      setrenwalLoading(false);
      submittingRef.current = false;
    }
  };
  const handleClickOpendue = (payment) => {
    setSelectedPayment(payment);

    setOpendue(true);
  };

  const handleClosedue = () => {
    setOpendue(false);
  };
  const handleDuePayment = async (formData) => {
    setLoading(true); // Optionally, you can remove this if it's not needed
    console.log("Payment processed successfully:", formData);
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    try {
      const result = await PtduePaymentClear(userToken, userId, formData);
      console.log("Payment processed successfully:", result);
      handleSnackbarOpen(result.message, "success");
      handleClosedue();
      setLoading(false); // Optionally, you can remove this if it's not needed
      fetchData();
    } catch (error) {
      console.error("Failed to process due payment:", error);
      handleSnackbarOpen(result.message, "success");
      setLoading(false); // Optionally, you can remove this if it's not needed
    }
  };

  const handleClickOpendueYearly = (payment) => {
    setSelectedYearlyPayment(payment);
    setOpendueYearly(true);
  };

  const handleClosedueYearly = () => {
    setOpendueYearly(false);
  };

  const handleYearlyDuePayment = async (formData) => {
    setLoading(true);
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    try {
      const result = await YearlyDuePaymentClear(userToken, userId, formData);
      handleSnackbarOpen(result.message, result.code === 200 ? "success" : "error");
      handleClosedueYearly();
      setLoading(false);
      fetchData();
    } catch (error) {
      console.error("Failed to process yearly due payment:", error);
      handleSnackbarOpen("Failed to process yearly due payment", "error");
      setLoading(false);
    }
  };
  const handleOpenDialog = () => {
    setDialogData(fetchdatarow); // Set the card data
    setDialogOpen(true);
  };

  const handleCloseDialog = () => setDialogOpen(false);
  const handleChangetab = (event, newValue) => {
    setValue(newValue);
  };
  const [FormData, setFormData] = useState({
    member_id: "",
    discount: 0,
    package: "",
    packagevalue: "",
    totalpaybleamount: "",
    discount: "",
    payableamount: "",
    modeofpayment: "",
    payingamount: "",
    dueamount: "",
    activationdate: null,
    dateofpayment: null,
    trainer:"",
    ptSession: "",
    slot:"",
    startTime: null,  // Added startTime
    endTime: null,    // Added endTime
  });

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide all borders for all children
    "& td, & th": {
      border: 0,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));



  const openPauseModal = () => {
    setIsPauseModal(true);
  };
  const closePauseModal = () => {
    setIsPauseModal(false);
  };
  // const handleClickPause = () => {
  //     setPauseOrResume(false)
  //     setIsPauseModal(false);

  // }

  
  const closeResumeModal = () => {
    setIsResumeModal(false);
  };
  const handleClickResume = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata

      const res = await MembershipResume(
        userToken,
        conversation_id,
        resumeDate,
        userId
      );

      if (res.code == "200") {
        console.log(res.data);
        fetchData();
        setPauseOrResume(true);
        setIsResumeModal(false);
        handleSnackbarOpen(res.message, "success");

        setLoading(false); // Optionally, you can remove this if it's not needed
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  
  const openAddPTPModal = (previousPayment = null) => {
    fetchDropdowndata();
    const today = dayjs();
    let activationdate = today;
    let trainer = "";
    if (previousPayment) {
      setAddPTPPreviousPayment(previousPayment);
      if (previousPayment.end_date) {
        const parts = previousPayment.end_date.split("-");
        if (parts.length === 3) {
          const [day, month, year] = parts;
          activationdate = dayjs(`${year}-${month}-${day}`);
        }
      }
      if (previousPayment.trainer_id != null && previousPayment.trainer_id !== "") {
        trainer = String(previousPayment.trainer_id);
      }
    } else {
      setAddPTPPreviousPayment(null);
    }
    setFormData({
      member_id: "",
      package: "",
      packagevalue: "",
      totalpaybleamount: "",
      discount: "",
      payableamount: "",
      modeofpayment: "",
      payingamount: "",
      dueamount: "",
      activationdate,
      dateofpayment: today,
      trainer,
      ptSession: "",
      slot: "",
      startTime: null,
      endTime: null,
    });
    setIsAddPTPModal(true);
  };
  const closeAddPTPModal = () => {
    setIsAddPTPModal(false);
    setAddPTPPreviousPayment(null);
    setFormData({
      member_id: "",
      package: "",
      packagevalue: "",
      totalpaybleamount: "",
      discount: "",
      payableamount: "",
      modeofpayment: "",
      payingamount: "",
      dueamount: "",
      activationdate: null,
      dateofpayment: null,
      trainer: "",
      ptSession: "",
      slot: "",
      startTime: null,
      endTime: null,
    });
    setStartTime(null);
    setEndTime(null);
    setSubmitted(false);
    setPtTrainerSlotInfo(null);
    setPtTrainerSlotLoading(false);
  };

  // When Add PT modal opens with previous payment, resolve trainer by name once dropdown is loaded
  useEffect(() => {
    if (!isAddPTPModal || !addPTPPreviousPayment || FormData.trainer) return;
    if (!Dropdowndatatrainer?.length || !addPTPPreviousPayment.trainer_name) return;
    const match = Dropdowndatatrainer.find(
      (row) => String(row.name).trim().toLowerCase() === String(addPTPPreviousPayment.trainer_name).trim().toLowerCase()
    );
    if (match) {
      setFormData((prev) => ({ ...prev, trainer: String(match.id) }));
    }
  }, [isAddPTPModal, addPTPPreviousPayment, Dropdowndatatrainer]);

  useEffect(() => {
    if (!isAddPTPModal || !FormData.trainer) {
      setPtTrainerSlotInfo(null);
      setPtTrainerSlotLoading(false);
      return undefined;
    }
    let cancelled = false;
    setPtTrainerSlotLoading(true);
    setPtTrainerSlotInfo(null);
    (async () => {
      try {
        const raw = localStorage.getItem("userdata");
        if (!raw) {
          if (!cancelled) setPtTrainerSlotLoading(false);
          return;
        }
        const { token } = JSON.parse(raw);
        const res = await PtTrainerSlotTimes(token, FormData.trainer);
        if (cancelled) return;
        if (res.code === "200" || res.code === 200) {
          setPtTrainerSlotInfo(res.data ?? null);
        } else {
          setPtTrainerSlotInfo(null);
        }
      } catch (e) {
        if (!cancelled) {
          console.error(e);
          setPtTrainerSlotInfo(null);
        }
      } finally {
        if (!cancelled) setPtTrainerSlotLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isAddPTPModal, FormData.trainer]);

  // Renewing an active PT: once the trainer's slot windows are loaded, carry
  // over the previous session (morning/evening) and start/end time instead
  // of leaving the slot picker blank.
  useEffect(() => {
    if (!isAddPTPModal || !addPTPPreviousPayment || !ptTrainerSlotInfo || FormData.ptSession) return;
    const prevSlot = addPTPPreviousPayment.pt_slot_time ?? addPTPPreviousPayment.slot;
    if (!prevSlot) return;
    const resolved = resolveSessionFromSlotString(prevSlot, ptTrainerSlotInfo);
    if (!resolved) return;
    setFormData((prev) => ({
      ...prev,
      ptSession: resolved.session,
      startTime: resolved.start,
      endTime: resolved.end,
    }));
  }, [isAddPTPModal, addPTPPreviousPayment, ptTrainerSlotInfo, FormData.ptSession]);

  // const handleClickAddPTP = () => {
  //     // setPauseOrResume(true)
  //     setIsAddPTPModal(false);

  // }
  

  const [ympPackageAmount, setYmpPackageAmount] = useState("");
  const [ympPaymentMode, setYmpPaymentMode] = useState("cash");
  const [ympAdmissionValueId, setYmpAdmissionValueId] = useState("");
  const [ympSubmitting, setYmpSubmitting] = useState(false);
  const [ympLoadingPackageValue, setYmpLoadingPackageValue] = useState(false);
  // Paying amount defaults to the full package amount (fully paid, matches old
  // behavior) but is editable so staff can record a partial payment, with the
  // difference tracked as due — same convention as Main/Trainer package payments.
  const [ympPayingAmount, setYmpPayingAmount] = useState("");
  const [ympOffer, setYmpOffer] = useState("0");

  useEffect(() => {
    const payble = parseFloat(ympPackageAmount) || 0;
    const offer  = parseFloat(ympOffer) || 0;
    setYmpPayingAmount(String(Math.max(0, payble - offer)));
  }, [ympPackageAmount, ympOffer]);

  const ympDue = useMemo(() => {
    const payble = parseFloat(ympPackageAmount) || 0;
    const paying = parseFloat(ympPayingAmount) || 0;
    const offer  = parseFloat(ympOffer) || 0;
    return Math.max(0, payble - paying - offer);
  }, [ympPackageAmount, ympPayingAmount, ympOffer]);

  const ptTimeBounds = useMemo(() => {
    if (!ptTrainerSlotInfo || !FormData.ptSession) return null;
    return getSessionTimeBoundsForPickers(ptTrainerSlotInfo, FormData.ptSession);
  }, [ptTrainerSlotInfo, FormData.ptSession]);

  const ptEndPickerMinTime = useMemo(() => {
    if (!ptTimeBounds) return null;
    const { slotStart } = ptTimeBounds;
    if (!FormData.startTime) return slotStart;
    const st = dayjs(FormData.startTime);
    if (!st.isValid()) return slotStart;
    const afterStart = st.add(1, "minute");
    return afterStart.isAfter(slotStart) ? afterStart : slotStart;
  }, [ptTimeBounds, FormData.startTime]);

  /** Same as New Member: admission-value/dropdown list + get/value for amount */
  const handleYmpAdmissionChange = async (e) => {
    const selectedId = e.target.value;
    setYmpAdmissionValueId(selectedId);
    if (!selectedId) {
      setYmpPackageAmount("");
      return;
    }
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      setYmpLoadingPackageValue(true);
      const res = await PackageAdmissionDropdownvalue(userToken, userId, selectedId);
      if (res.code === "200" || res.code === 200) {
        const raw = res.data;
        const amt =
          raw != null && typeof raw === "object"
            ? raw.admission_value ?? raw.package_amount ?? raw.value
            : raw;
        if (amt != null && amt !== "") setYmpPackageAmount(String(amt));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setYmpLoadingPackageValue(false);
    }
  };

  const openAddYMPModal = () => {
    fetchDropdownAdmissiondata();
    setYmpPackageAmount("");
    setYmpOffer("0");
    setYmpPaymentMode("cash");
    setYmpAdmissionValueId("");
    // Pre-fill Start date with latest yearly end_date, or latest PT end_date if no yearly
    let initialStartDate = null;
    const parseDdmmyyyy = (str) => {
      if (!str || typeof str !== "string") return null;
      const parts = str.split(/[-/]/);
      if (parts.length !== 3) return null;
      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const y = parseInt(parts[2], 10);
      if (isNaN(d) || isNaN(m) || isNaN(y)) return null;
      return new Date(y, m, d);
    };
    const dates = [];
    if (yearlymembership?.length) {
      yearlymembership.forEach((row) => {
        const ed = row?.end_date ?? row?.expired_date ?? "";
        const d = parseDdmmyyyy(ed);
        if (d) dates.push(d);
      });
    }
    if (dates.length === 0 && ptpaymentrow?.length) {
      ptpaymentrow.forEach((row) => {
        const ed = row?.end_date ?? "";
        const d = parseDdmmyyyy(ed);
        if (d) dates.push(d);
      });
    }
    if (dates.length > 0) {
      const latest = new Date(Math.max(...dates.map((x) => x.getTime())));
      initialStartDate = latest;
    }
    setStartDate(initialStartDate);
    setEndDate(null);
    setIsAddYMPModal(true);
  };
  const closeAddYMPModal = () => {
    setIsAddYMPModal(false);
    setEndDate(null);
    setStartDate(null);
    setYmpPackageAmount("");
    setYmpOffer("0");
    setYmpPaymentMode("cash");
    setYmpAdmissionValueId("");
  };

  const [joiningdateadd, setjoiningdateadd] = useState(null);
  const fetchData = async (value = "") => {
    setLoading(true);
    // setHasMore(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
      const limit = 10; // Example limit
      const index = 0; // Example index
      // console.log(conversation_id);
      const res = await retrieveGymMember(userToken, conversation_id, userId);

      if (res.code == "200") {
        setetchdatarow(res.data);
        const joiningDate = new Date(res.data.joining_date);
        const formattedJoiningDate = `${String(joiningDate.getDate()).padStart(2, '0')}/${String(joiningDate.getMonth() + 1).padStart(2, '0')}/${joiningDate.getFullYear()}`;
    
        setjoiningdateadd(formattedJoiningDate); // Set formatted date
    
        setpaymentrow(res.data.payments ? [res.data.payments] : []);
        console.log(res.data.payments);
        const ptData = res.data.pt_data;
        setptpaymentrow(
          Array.isArray(ptData) ? ptData : ptData && typeof ptData === 'object' ? [ptData] : []
        );
        const yp = res.data.yearly_package_payments;
        setyearlymembership(Array.isArray(yp) ? yp : yp && typeof yp === "object" ? [yp] : []);

        console.log(
          "yearly_package_payments:",
          res.data.yearly_package_payments
        );
        // return false;
        setLoading(false);
      } else {
        // console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchData();
  }, [conversation_id]);
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate("/");
    }
  }, []);
  const fetchDropdowndata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PtTrainerDropdown(userToken, userId);
        
      if (res.code == "200") {
        setDropdowndatatrainer(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  const fetchDropdowndatatrainer = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PtPackageDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdowndata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const handlePackageChange = (paymentData) => {
    // Replace 'navigate' with your routing logic (e.g., useHistory in React Router v5, useNavigate in v6)
    navigate("/change-package-", { state: { paymentData } });
  };
  
  const handlepayblevalueChange = async (e) => {
    // Update state with the selected package
    const selectedPackageId = e.target.value;
    setFormData({ ...FormData, package: selectedPackageId });

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PtPackageDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );

      if (res.code == "200") {
        const packageAmount = res.data;
        setFormData((prevState) => ({
          ...prevState,
          packagevalue: packageAmount,
          totalpaybleamount: packageAmount,
        }));

        setpackageamount(packageAmount);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if necessary
    }
  };
  const [prevPackageAmount, setPrevPackageAmount] = useState(0);
  const handlepayblevalueChangemember = async (e) => {
    const selectedPackageId = e.target.value;
    // NB: the "Renew Package" dropdown renders from Dropdowndatamember (main
    // packages, via PackageDropdownafteradmission) — Dropdowndata is a
    // different list (PT packages), so it must not be used for this lookup.
    const selectedPackage = Dropdowndatamember.find(
      (row) => row.id === selectedPackageId
    );
    // The backend uses whatever start_date is sent here (unlike Change
    // Package / Repeat Package, which both ignore it) — see renewPackage().
    const computedEndDate = selectedPackage?.duration && formdueData.start_date
      ? dayjs(formdueData.start_date).add(Number(selectedPackage.duration), "day").format("YYYY-MM-DD")
      : "";

    setFormdueData({
      ...formdueData,
      package_id: selectedPackageId,
      packagename: selectedPackage?.name || "",
      end_date_preview: computedEndDate,
    });

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageDropdownvalueafteradmission(
        userToken,
        userId,
        selectedPackageId,
        conversation_id,
      );

      if (res.code == "200") {
        // API may return amount_to_pay (new) or package_amount (legacy) — handle both
        const rawData = res.data;
        const packageAmount =
          (typeof rawData === 'number' ? rawData : null) ??
          rawData?.amount_to_pay ??
          rawData?.package_amount ??
          0;

        setFormdueData((prevState) => {
          const currentTotal = parseFloat(prevState.total_payble_amount) || 0;
          const total_payble_amount = currentTotal === 0
            ? packageAmount
            : currentTotal - prevPackageAmount + packageAmount;

          return {
            ...prevState,
            total_payble_amount,
            payble_amount: total_payble_amount,
            paying_amount: total_payble_amount,
          };
        });

        setPrevPackageAmount(packageAmount);
      } else {
        console.error("API error:", res.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleTotalPayableAmountChange = (e) => {
    const enteredValue = e.target.value;

    // If entered value is greater than the package amount, set it to the package amount
    const totalPayableAmount =
      enteredValue > packageamount ? packageamount : enteredValue;

    // Update state with the total payable amount
    setFormData({ ...FormData, totalpaybleamount: totalPayableAmount });
  };

  // Function to generate the helper text
  const generateHelperText = () => {
    return FormData.totalpaybleamount > packageamount
      ? "Total payable amount cannot exceed the package value"
      : "";
  };
  const getMinStartDate = () => {
    const { end_date } = formdueData; // Get end_date from form data

    console.log("Original end_date:", end_date); // For debugging

    if (end_date) {
      const [day, month, year] = end_date.split("-");
      const parsedEndDate = new Date(`${year}-${month}-${day}`);

      console.log("Parsed end_date (Date Object):", parsedEndDate); // For debugging

      const today = new Date();
      console.log("Today's date:", today); // For debugging

      const minStartDate = parsedEndDate >= today ? end_date : ""; // Return empty string if end_date is in the past
      console.log("Min Start Date:", minStartDate); // For debugging
      return minStartDate.split("-").reverse().join("-"); // Return in YYYY-MM-DD format
    }

    return ""; // Default to empty if no end_date
  };
  const handleChangePaymentMode = (event) => {
    const { name, value } = event.target;
    setFormdueData({
      ...formdueData,
      [name]: value
    });
  };
  
  const handleDiscountChange = (e) => {
    // Parse the discount value as a number, defaulting to 0 if it's empty or not a valid number
    const discount = parseFloat(e.target.value) || 0;

    // Calculate the new payable amount after deducting the discount
    const newPayableAmount = FormData.totalpaybleamount - discount;

    // Update the form data with the new discount and payable amount
    setFormData({
      ...FormData,
      discount: discount,
      payingamount: newPayableAmount,
    });
  };
  /** HH:mm for API slot; supports Dayjs (TimePicker) and already-formatted strings */
  const formatTimeSafe = (v) => {
    if (v == null || v === "") return "";
    if (typeof v === "string") {
      const t = v.trim();
      const m = t.match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
      if (m) {
        const h = String(Math.min(23, parseInt(m[1], 10))).padStart(2, "0");
        const min = String(Math.min(59, parseInt(m[2], 10))).padStart(2, "0");
        return `${h}:${min}`;
      }
    }
    const d = dayjs(v);
    return d.isValid() ? d.format("HH:mm") : "";
  };

  const buildPTSlotString = () => {
    const startStr = formatTimeSafe(FormData.startTime);
    const endStr = formatTimeSafe(FormData.endTime);
    return startStr && endStr ? `${startStr}-${endStr}` : "";
  };

  const handleClickAddPTP = () => {
    setSubmitted(true);

    // Do NOT overwrite FormData.startTime/endTime with strings — that breaks dayjs() on confirm
    // and yields empty slot / "-" on the API.
    const slotStr = buildPTSlotString();

    const updatedFormData = {
      ...FormData,
      slot: slotStr,
    };

    const requiredFields = [
      "packagevalue",
      "package",
      "totalpaybleamount",
      "modeofpayment",
      "payingamount",
      "activationdate",
      "dateofpayment",
      "trainer",
      "slot",
      "startTime",
      "endTime",
    ];

    const emptyFields = requiredFields.filter((field) => !updatedFormData[field]);
    if (emptyFields.length > 0) {
      handleSnackbarOpen("Please fill all required fields.", "error");
      return;
    }

    const st = FormData.startTime ? dayjs(FormData.startTime) : null;
    const et = FormData.endTime ? dayjs(FormData.endTime) : null;
    if (st && et && st.isValid() && et.isValid() && et.isBefore(st)) {
      handleSnackbarOpen("End Time must be later than Start Time", "error");
      return;
    }

    if (FormData.trainer) {
      if (!FormData.ptSession) {
        handleSnackbarOpen("Choose Morning or Evening session.", "error");
        return;
      }
      if (ptTrainerSlotLoading) {
        handleSnackbarOpen("Please wait — loading trainer schedule.", "error");
        return;
      }
      const hasSlots =
        ptTrainerSlotInfo &&
        (hasTrainerMorningSlot(ptTrainerSlotInfo) ||
          hasTrainerEveningSlot(ptTrainerSlotInfo));
      if (!hasSlots) {
        handleSnackbarOpen(
          "Trainer schedule could not be loaded. Re-select the trainer.",
          "error"
        );
        return;
      }
      const sessionOk =
        (FormData.ptSession === "morning" && hasTrainerMorningSlot(ptTrainerSlotInfo)) ||
        (FormData.ptSession === "evening" && hasTrainerEveningSlot(ptTrainerSlotInfo));
      if (!sessionOk) {
        handleSnackbarOpen("Pick a valid session for this trainer.", "error");
        return;
      }
      if (!isPtStartTimeWithinSessionSlot(st, ptTrainerSlotInfo, FormData.ptSession)) {
        handleSnackbarOpen(
          `Start time is outside the selected session. ${trainerSlotAllowedStartSummaryForSession(
            ptTrainerSlotInfo,
            FormData.ptSession
          )}`,
          "error"
        );
        return;
      }
      if (!isPtEndTimeWithinSessionSlot(et, ptTrainerSlotInfo, FormData.ptSession)) {
        handleSnackbarOpen(
          "End time must be inside the same session window as start time.",
          "error"
        );
        return;
      }
    }

    setConfirmAddPTPOpen(true);
  };

  const doAddPTP = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setConfirmAddPTPOpen(false);
    setAddPTPSubmitting(true);
    const slotStr = buildPTSlotString();
    const updatedFormData = {
      ...FormData,
      slot: slotStr,
      // Send date-only YYYY-MM-DD to avoid timezone shift (e.g. 20th becoming 19th in UTC)
      dateofpayment: FormData.dateofpayment
        ? dayjs(FormData.dateofpayment).format("YYYY-MM-DD")
        : null,
      activationdate: FormData.activationdate
        ? dayjs(FormData.activationdate).format("YYYY-MM-DD")
        : null,
    };
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    try {
      const res = await TrainerPayment(userToken, conversation_id, updatedFormData);
      if (res.code === "200" || res.code === 200) {
        closeAddPTPModal();
        setFormData({
          member_id: "",
          package: "",
          packagevalue: "",
          totalpaybleamount: "",
          discount: "",
          payableamount: "",
          modeofpayment: "",
          payingamount: "",
          activationdate: null,
          dateofpayment: null,
          trainer: "",
          ptSession: "",
          slot: "",
          startTime: null,
          endTime: null,
        });
        fetchData();
        handleSnackbarOpen(res.message || "Payment done successfully", "success");
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("An error occurred. Please try again.", "error");
    } finally {
      setAddPTPSubmitting(false);
      submittingRef.current = false;
    }
  };
  

  const fetchDropdowndatarenwal = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageDropdownafteradmission(userToken, userId);

      if (res.code == "200") {
        setDropdowndatamember(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchDropdowndatarenwal();
    fetchDropdownAdmissiondata();
    fetchDropdowndatatrainer();
  }, []);
  const tabStyle = (isActive) => ({
    textDecoration: "none",
    flexGrow: 1,
    textTransform: "none",
    fontWeight: "bold",
    marginRight: "10px",
    backgroundColor: isActive ? "#D8E2FF" : "inherit",
    borderRadius: "10px 10px 0px 0px",
    borderBottom: isActive ? "2px solid #005AC1" : "none",
    color: isActive ? "#005AC1" : "inherit",
  });

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (date) {
      const newEndDate = dayjs(date).add(365, "day").toDate(); // Add 365 days using dayjs
      setEndDate(newEndDate);
      console.log(newEndDate);
    } else {
      setEndDate(null);
    }
  };

  const handleClickAddYMP = async () => {
    if (!conversation_id || !startDate || !ympAdmissionValueId) {
      handleSnackbarOpen("Start date and admission package are required.", "error");
      return;
    }
    const amt = Number(ympPackageAmount);
    if (!ympPackageAmount || Number.isNaN(amt) || amt <= 0) {
      handleSnackbarOpen("Enter a valid package amount.", "error");
      return;
    }
    const payingAmt = ympPayingAmount === "" ? amt : Number(ympPayingAmount);
    if (Number.isNaN(payingAmt) || payingAmt < 0) {
      handleSnackbarOpen("Enter a valid paying amount.", "error");
      return;
    }
    const offerAmt = Number(ympOffer) || 0;
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    setYmpSubmitting(true);
    try {
      const res = await addYearlyPackageIfExpired(userToken, {
        member_id: Number(conversation_id),
        // package_amount is what's actually collected right now (matches the
        // backend's due-tracking convention); payble_amount is the full price.
        package_amount: payingAmt,
        payble_amount: amt,
        offer: offerAmt,
        payment_mode: ympPaymentMode,
        start_date: dayjs(startDate).format("YYYY-MM-DD"),
        admission_value_id: Number(ympAdmissionValueId),
      });
      if (res.code === 200 || res.code === "200") {
        closeAddYMPModal();
        handleSnackbarOpen(res.message || "Yearly package added", "success");
        fetchData();
      } else {
        handleSnackbarOpen(res.message || "Request failed", "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen(error?.message || "Request failed", "error");
    } finally {
      setYmpSubmitting(false);
    }
  };

  const handlePayment = (paymentData) => {
    console.log(paymentData);
    navigate("/payment", { state: { paymentData } });
  };
  const [selectedDate, setSelectedDate] = useState(null); // State variable to hold the selected date

  const handleDateChange = (date) => {
    setSelectedDate(date); // Update the selected date when user selects a date
  };
  const handleClickPause = async () => {
    if (selectedDate) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata

        const res = await MembershipPause(
          userToken,
          conversation_id,
          selectedDate,
          userId
        );

        if (res.code == "200") {
          console.log(res.data);
          setPauseOrResume(false);
          setIsPauseModal(false);
          fetchData();
          setLoading(false);
        } else {
          handleSnackbarOpen(res.message, "error");
          // console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handlepayblevalueadmissionChange = async (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdownadmissiondata.find(
      (row) => row.id === selectedPackageId
    );
  
    // setFormdueData({
    //   ...formdueData,
    //   membership: selectedPackageId,
    //   membership_packagename: selectedPackage?.name || "",
    // });
    setRenewalType(selectedPackageId);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
  
      const res = await PackageAdmissionDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );
  
      if (res.code == "200") {
        const packageAmount = parseFloat(res.data) || 0;
  
      
        // Update the previous admission amount to the current selection's amount
        setRenewalAmount(packageAmount);
      } else {
        console.error("Error response:", res.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [prevAdmissionAmount, setPrevAdmissionAmount] = useState(0);
  const handlepayblevalueadmissionrepeat = async (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdownadmissiondata.find(
      (row) => row.id === selectedPackageId
    );
  
    setFormdueData({
      ...formdueData,
      membership: selectedPackageId,
      membership_packagename: selectedPackage?.name || "",
    });
  
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
  
      const res = await PackageAdmissionDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );
  
      if (res.code == "200") {
        const packageAmount = parseFloat(res.data) || 0;

        setFormdueData((prevState) => ({
          ...prevState,
          membershipvalue: packageAmount,
          // Yearly membership is its own separate payment — payble defaults to the
          // full price and paying auto-fills to payble minus offer (edit either for
          // a partial/due yearly payment, same convention as "Add yearly membership").
          yearly_payble_amount: packageAmount,
          yearly_paying_amount: Math.max(0, packageAmount - (parseFloat(prevState.yearly_offer) || 0)),
        }));

        // Update the previous admission amount to the current selection's amount
        setPrevAdmissionAmount(packageAmount);
      } else {
        console.error("Error response:", res.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleYearlyOfferChange = (e) => {
    const offer = e.target.value;
    setFormdueData((prevState) => {
      const payble = parseFloat(prevState.yearly_payble_amount) || 0;
      const offerNum = parseFloat(offer) || 0;
      return {
        ...prevState,
        yearly_offer: offer,
        yearly_paying_amount: Math.max(0, payble - offerNum),
      };
    });
  };

  const handleYearlyPayingAmountChange = (e) => {
    setFormdueData((prevState) => ({
      ...prevState,
      yearly_paying_amount: e.target.value,
    }));
  };

  const [selectedPaymentId, setselectedPaymentId] = useState("");
  const [isChangeTrainerDialogOpen, setIsChangeTrainerDialogOpen] = useState(false); // Specific state name
  const [confirmChangeTrainerOpen, setConfirmChangeTrainerOpen] = useState(false);
  const [trainer, setTrainer] = useState("");
  const handleOpentrainerDialog = (id) => {
    setselectedPaymentId(id);
    setIsChangeTrainerDialogOpen(true);
    fetchDropdowndata(); // Call the function when the dialog opens
  };

  const handleClosetrainerDialog = () => {
    setIsChangeTrainerDialogOpen(false);
    setConfirmChangeTrainerOpen(false);
  };

  const handleTrainerChange = (event) => {
    setTrainer(event.target.value);
  };


  const handleTrainerChangeapi = async (formData) => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setLoading(true);
  
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    try {
      const result = await TrainerChange(userToken, selectedPaymentId, trainer);
      handleSnackbarOpen(result.message, "success");
      handleClosetrainerDialog();
      fetchData();
    } catch (error) {
      console.error("Failed to change trainer:", error);
      handleSnackbarOpen(error?.message || "Failed to change trainer.", "error");
    } finally {
      setLoading(false);
      submittingRef.current = false;
    }
  };

  const StyledButton = styled(Button)({
    backgroundColor: appColors.leaf,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: appColors.pine,
    },
    '&.MuiButton-outlined': {
      color: appColors.leaf,
      borderColor: appColors.leaf,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(31, 122, 84, 0.04)',
        borderColor: appColors.pine,
      },
    },
  });

  const handleRepeatClick = () => {
    setConfirmRepeatOpen(true);
  };

  const handleRepeatPackage = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setConfirmRepeatOpen(false);
    setrenwalLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const numericRepeatOffer = Number(repeatOffer);

      const response = await MembeRepeatPackage(
        userToken,
        userId,
        conversation_id,
        packageIdrepeat,
        repeatModeOfPayment,
        numericRepeatOffer,
        renewalType,
        renewalAmount
      );

      if (response.code === "200") {
        setSnackbarMessage(response.message);
        setSnackbarSeverity("success");
        setOpenToast(true);
        repeatHandleClose();
        fetchData();
      } else {
        setSnackbarMessage(response.message || "Error occurred while repeating package.");
        setSnackbarSeverity("error");
        setOpenToast(true);
      }
    } catch (error) {
      setSnackbarMessage("Failed to repeat package: " + error.message);
      setSnackbarSeverity("error");
      setOpenToast(true);
    } finally {
      setrenwalLoading(false);
      submittingRef.current = false;
    }
  };

  const StyledCard = styled(Card)(({ theme }) => ({
    background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.pine} 100%)`,
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(31, 122, 84, 0.2)',
    overflow: 'hidden',
    transition: 'transform 0.3s, box-shadow 0.3s',
    height: '100%',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 12px 40px rgba(31, 122, 84, 0.3)',
    },
  }));

  const CardHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3),
    background: 'rgba(255, 255, 255, 0.1)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
  }));

  const CardContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
  }));

  const InfoSection = styled(Box)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: '12px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }));

  const InfoLabel = styled(Typography)(({ theme }) => ({
    color: '#93c5fd',
    fontSize: '0.875rem',
    fontWeight: '500',
    marginBottom: theme.spacing(0.5),
  }));

  const InfoValue = styled(Typography)(({ theme }) => ({
    color: '#fff',
    fontSize: '1rem',
  }));

  const ActionButton = styled(Button)(({ theme, color = 'primary' }) => ({
    backgroundColor: color === 'primary' ? appColors.leaf : color === 'warning' ? '#f59e0b' : '#ef4444',
    color: '#fff',
    borderRadius: '8px',
    padding: '8px 16px',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: color === 'primary' ? appColors.pine : color === 'warning' ? '#d97706' : '#dc2626',
      transform: 'scale(1.02)',
    },
  }));

  const StatusChip = styled(Box)(({ expired }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: expired ? 'rgba(239, 68, 68, 0.1)' : 'rgba(34, 197, 94, 0.1)',
    color: expired ? '#ef4444' : '#22c55e',
    borderRadius: '20px',
    padding: '6px 12px',
    border: `1px solid ${expired ? 'rgba(239, 68, 68, 0.3)' : 'rgba(34, 197, 94, 0.3)'}`,
  }));

  return (
    <Box sx={{ display: "flex", minHeight: "100vh",  background: "linear-gradient(90deg, #ff7c43, #ffb547, #42a5f5, #66bb6a, #ab47bc)",
      backgroundSize: "300% 300%",
      animation: "gradientAnimation 10s ease infinite", }}>
      <Header />
      <CssBaseline />
      <style>
        {`
          @keyframes gradientAnimation {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflowY: value === 0 ? "auto" : "hidden",
          padding: "20px",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
             
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div style={{ display: "flex", flexGrow: 1, marginTop: "50px", }}>
            <div style={{ flex: 1, marginTop: "15px" }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    background: "#ffffff",
                    padding: "16px 24px",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    marginBottom: "20px",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontWeight: "bold",
                        color: appColors.evergreen,
                        fontSize: "1.25rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        display: "flex",
                        alignItems: "center",
                        gap: 2
                      }}
                    >
                      <Box
                        sx={{
                          width: "4px",
                          height: "24px",
                          background: `linear-gradient(to bottom, ${appColors.evergreen}, ${appColors.leaf})`,
                          borderRadius: "2px",
                          marginRight: "12px"
                        }}
                      />
                      Member Details
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  <Tabs
                    value={value}
                    onChange={handleChangetab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                      sx={{
                        '& .MuiTab-root': {
                          color: 'rgba(26, 35, 126, 0.7)',
                          '&.Mui-selected': {
                            color: appColors.leaf,
                          },
                        },
                        '& .MuiTabs-indicator': {
                          backgroundColor: appColors.leaf,
                          height: '3px',
                          borderRadius: '3px',
                        },
                      }}
                  >
                    <Tab
                      sx={{
                        ...tabStyle(0 === value),
                          color: appColors.leaf,
                          '&.Mui-selected': {
                            backgroundColor: 'rgba(26, 35, 126, 0.1)',
                          },
                      }}
                      label="Payment History"
                      {...a11yProps(0)}
                    />
                  </Tabs>
                  <Button
                    variant="contained"
                      onClick={() => navigate("/memberlist")}
                    sx={{
                        background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 100%)`,
                        color: "#fff",
                      textTransform: "none",
                        fontWeight: "600",
                        padding: "8px 24px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(26, 35, 126, 0.15)",
                        '&:hover': {
                          background: `linear-gradient(135deg, ${appColors.leaf} 0%, ${appColors.evergreen} 100%)`,
                          boxShadow: "0 6px 16px rgba(26, 35, 126, 0.2)",
                          transform: "translateY(-1px)",
                        },
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "4px"
                        }}
                  >
                        ←
                      </Box>
                    View List
                  </Button>
                    </Box>
                  </Box>
                  {/* Package expiry summary in header */}
                  {(() => {
                    const parseDdMmYyyy = (str) => {
                      if (!str || typeof str !== "string") return null;
                      const parts = str.split(/[-/]/);
                      if (parts.length !== 3) return null;
                      const d = parseInt(parts[0], 10);
                      const m = parseInt(parts[1], 10) - 1;
                      const y = parseInt(parts[2], 10);
                      if (isNaN(d) || isNaN(m) || isNaN(y)) return null;
                      return new Date(y, m, d);
                    };
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const daysFromToday = (date) => {
                      if (!date) return null;
                      const d = new Date(date);
                      d.setHours(0, 0, 0, 0);
                      return Math.ceil((d - today) / 86400000);
                    };
                    const items = [];
                    const flatPayments = Array.isArray(paymentrow) && paymentrow.length && Array.isArray(paymentrow[0]) ? paymentrow[0] : (paymentrow || []);
                    flatPayments.forEach((p, i) => {
                      const endStr = p?.end_date ?? p?.expired_date ?? "";
                      if (!endStr) return;
                      const expired = p.expired === "Yes";
                      const days = expired
                        ? (p.expired_days ? -p.expired_days : daysFromToday(parseDdMmYyyy(endStr)))
                        : (p.days_left != null ? p.days_left : daysFromToday(parseDdMmYyyy(endStr)));
                      items.push({ label: "Main package", endDate: endStr, days, expired, key: `p-${i}` });
                    });
                    (ptpaymentrow || []).forEach((p, i) => {
                      const endStr = p?.end_date ?? p?.expired_date ?? "";
                      if (!endStr) return;
                      const expired = p.expired === "Yes";
                      const days = expired
                        ? (p.expired_days ? -p.expired_days : daysFromToday(parseDdMmYyyy(endStr)))
                        : (p.days_left != null ? p.days_left : daysFromToday(parseDdMmYyyy(endStr)));
                      items.push({ label: "PT", endDate: endStr, days, expired, key: `pt-${i}` });
                    });
                    (yearlymembership || []).forEach((row, i) => {
                      const endStr = row?.end_date ?? row?.expired_date ?? "";
                      if (!endStr) return;
                      const days = daysFromToday(parseDdMmYyyy(endStr));
                      items.push({ label: "Yearly Renewals", endDate: endStr, days, expired: days != null && days < 0, key: `ym-${i}` });
                    });
                    if (items.length === 0) return null;
                    return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", pt: 0.5, borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                        {items.map(({ label, endDate, days, expired, key }) => (
                          <Box
                            key={key}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.75,
                              px: 1.5,
                              py: 0.75,
                              borderRadius: "10px",
                              bgcolor: expired ? "rgba(239, 68, 68, 0.08)" : "rgba(34, 197, 94, 0.08)",
                              border: `1px solid ${expired ? "rgba(239, 68, 68, 0.25)" : "rgba(34, 197, 94, 0.25)"}`,
                            }}
                          >
                            <Typography component="span" sx={{ fontSize: "0.75rem", fontWeight: 600, color: expired ? "#dc2626" : "#059669" }}>
                              {label}: {endDate}
                              {days != null && (expired ? ` · ${-days} days ago` : ` · ${days} days left`)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    );
                  })()}
                </Box>
              </Box>
              <TabPanel value={value} index={0}>
                <PaymentHistory
                  conversationId={conversation_id}
                  onGoBackToMemberDetails={() => setValue(1)}
                />
              </TabPanel>
              <div style={{ display: value === 0 ? "none" : "" }}>
                <Grid container spacing={2}>
                  {/* First Card - Member Details */}
                  <Grid size={{xs:6}}>
                    <Card
                      sx={{
                        background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 50%, #01579b 100%)`,
                        borderRadius: "20px",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
                        overflow: "hidden",
                        transition: "transform 0.3s, box-shadow 0.3s",
                        height: "100%",
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: "0 12px 40px rgba(13, 71, 161, 0.4)",
                        },
                      }}
                    >
                      {/* Header Section */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          p: 2,
                          background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                          backdropFilter: "blur(10px)",
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Tooltip title="Click to enlarge">
                            <Avatar
                              src={(fetchdatarow.image && fetchdatarow.image !== 'null') ? fetchdatarow.image : ''}
                              alt="Profile"
                              onClick={() => (fetchdatarow.image && fetchdatarow.image !== 'null') && setImagePreviewOpen(true)}
                              sx={{
                                width: 60,
                                height: 60,
                                border: "3px solid #fff",
                                transition: "transform 0.3s",
                                cursor: (fetchdatarow.image && fetchdatarow.image !== 'null') ? "pointer" : "default",
                                "&:hover": (fetchdatarow.image && fetchdatarow.image !== 'null') ? { transform: "scale(1.05)", opacity: 0.9 } : {},
                              }}
                            />
                          </Tooltip>
                          <Dialog
                            open={imagePreviewOpen}
                            onClose={() => setImagePreviewOpen(false)}
                            onClick={() => setImagePreviewOpen(false)}
                            PaperProps={{
                              sx: {
                                maxWidth: "90vw",
                                maxHeight: "90vh",
                                overflow: "hidden",
                                borderRadius: 2,
                                boxShadow: 24,
                              },
                            }}
                            slotProps={{ backdrop: { sx: { backgroundColor: "rgba(0,0,0,0.8)" } } }}
                          >
                            <DialogContent
                              onClick={(e) => e.stopPropagation()}
                              sx={{
                                p: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 280,
                                minHeight: 280,
                              }}
                            >
                              <Box
                                component="img"
                                src={(fetchdatarow.image && fetchdatarow.image !== 'null') ? fetchdatarow.image : ''}
                                alt="Profile (enlarged)"
                                sx={{
                                  maxWidth: "85vw",
                                  maxHeight: "85vh",
                                  objectFit: "contain",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </DialogContent>
                          </Dialog>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold" }}>
                              {fetchdatarow.name}
                            </Typography>
                            {fetchdatarow.from_followup && (
                              <Box sx={{
                                display: 'inline-flex', alignItems: 'center', gap: 0.5,
                                bgcolor: 'rgba(251,191,36,0.2)', border: '1px solid rgba(251,191,36,0.5)',
                                borderRadius: '999px', px: 1.2, py: 0.3,
                              }}>
                                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#fbbf24' }} />
                                <Typography sx={{ color: '#fbbf24', fontSize: '0.7rem', fontWeight: 700, letterSpacing: 0.3 }}>
                                  From Follow-up
                                </Typography>
                              </Box>
                            )}
                          </Box>
                          <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.78rem', mt: 0.3 }}>
                            {fetchdatarow.membership_number}
                          </Typography>
                        </Box>
                        </Box>
                        <Tooltip title="Edit member">
                          <IconButton
                            onClick={() =>
                              navigate("/newmember", {
                                state: { editMode: true, memberId: fetchdatarow.id, memberData: fetchdatarow },
                              })
                            }
                            sx={{
                              color: "#fff",
                              bgcolor: "rgba(255,255,255,0.12)",
                              "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>

                      {/* Main Content */}
                      <Box sx={{ p: 2 }}>
                        {/* Personal Information */}
                        <Box
                          sx={{
                            background: "linear-gradient(145deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.06))",
                            borderRadius: "12px",
                            p: 2.5,
                            mb: 2.5,
                            backdropFilter: "blur(5px)",
                            border: "1px solid rgba(255, 255, 255, 0.1)",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                          }}
                        >
                          <Grid container spacing={3}>
                        {[
                          { label: "Phone", value: fetchdatarow.phone },
                          { label: "Alternative No", value: fetchdatarow.alternate_phone },
                          { label: "Email", value: fetchdatarow.email },
                        ].map((item, index) => (
                              <Grid size={{xs:4}} key={index}>
                            <Typography
                              sx={{
                                    color: "#90caf9",
                                    fontSize: "0.8rem",  // Reduced from 0.9rem
                                    fontWeight: "600",
                                    mb: 1,
                              }}
                            >
                              {item.label}
                            </Typography>
                            <Typography
                              sx={{
                                    color: "#fff",
                                    fontSize: "0.95rem",  // Reduced from 1.1rem
                                    fontWeight: "500",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                                  {item.value || "N/A"}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                        </Box>

                        {/* Additional Details */}
                        <Box
                          sx={{
                            background: "linear-gradient(145deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.06))",
                            borderRadius: "12px",
                            p: 2.5,
                            mb: 2.5,
                            backdropFilter: "blur(5px)",
                            border: "1px solid rgba(255, 255, 255, 0.1)",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                          }}
                        >
                          <Grid container spacing={3}>
                        {[
                          { label: "Address", value: fetchdatarow.address },
                          { label: "Date of Birth", value: fetchdatarow.dob },
                          { label: "Gender", value: fetchdatarow.sex },
                          { label: "Height", value: fetchdatarow.height },
                              { label: "Weight", value: fetchdatarow.weight },
                              { label: "Id Type", value: fetchdatarow.identification_type },
                              { label: "Id No", value: fetchdatarow.identification_id },
                        ].map((item, index) => (
                              <Grid size={{xs:3}} key={index}>
                            <Typography
                              sx={{
                                    color: "#90caf9",
                                    fontSize: "0.8rem",  // Reduced from 0.9rem
                                    fontWeight: "600",
                                    mb: 1,
                              }}
                            >
                              {item.label}
                            </Typography>
                            <Typography
                              sx={{
                                    color: "#fff",
                                    fontSize: "0.95rem",  // Reduced from 1.1rem
                                    fontWeight: "500",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                                  {item.value || "N/A"}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                        </Box>

                        {/* Action Button */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Button
                            onClick={handleOpenDialog}
                            size="small"
                            sx={{
                              background: `linear-gradient(135deg, #2196f3 0%, ${appColors.leaf} 100%)`,
                              color: "#fff",
                              borderRadius: "8px",
                              padding: "8px 16px",
                              fontSize: "0.875rem",
                              fontWeight: "bold",
                              textTransform: "none",
                              border: "1px solid rgba(255, 255, 255, 0.1)",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                              "&:hover": {
                                background: `linear-gradient(135deg, ${appColors.leaf} 0%, ${appColors.leaf} 100%)`,
                                transform: "scale(1.02)",
                                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
                              },
                            }}
                          >
                            View Details
                          </Button>
                        </Box>
                      </Box>
                    </Card>
                  </Grid>

                  {/* Payment Cards */}
                  {paymentrow &&
                    paymentrow.map((payment, index) => (
                      <Grid size={{ xs: 12, md: 6 }} key={index} sx={{ minWidth: { xs: "100%", md: 340 } }}>
                          <Card
                            sx={{
                              background: "linear-gradient(165deg, #e0e7ff 0%, #c7d2fe 35%, #a5b4fc 100%)",
                              border: "1px solid rgba(99, 102, 241, 0.25)",
                              borderRadius: "20px",
                              boxShadow: "0 4px 24px rgba(79, 70, 229, 0.15), 0 1px 3px rgba(0,0,0,0.06)",
                              overflow: "hidden",
                              transition: "box-shadow 0.3s ease, transform 0.2s ease",
                              height: "100%",
                              "&:hover": {
                                boxShadow: "0 12px 40px rgba(79, 70, 229, 0.2), 0 4px 12px rgba(0,0,0,0.08)",
                                transform: "translateY(-2px)",
                              },
                            }}
                          >
                          {/* Premium Header */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: 1.5,
                                p: 2.5,
                                background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.06)",
                                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)",
                              }}
                            >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                              <Typography
                                variant="h6"
                                onClick={() => handlerenwalChange(paymentrow)}
                                sx={{
                                  color: "#f8fafc",
                                  fontWeight: 700,
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  textUnderlineOffset: "4px",
                                  fontSize: "1.15rem",
                                  letterSpacing: "0.02em",
                                  "&:hover": { color: "#cbd5e1" }
                                }}
                              >
                                Renewals
                              </Typography>
                              <IconButton
                                size="small"
                                sx={{
                                  color: "rgba(248, 250, 252, 0.9)",
                                  "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", color: "#fff" }
                                }}
                                onClick={() => handlerenwalChange(paymentrow)}
                              >
                                <RenewIcon sx={{ fontSize: "1.2rem" }} />
                              </IconButton>
                            </Box>
                                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                              <Button
                                onClick={() => handleNavigate(payment.invoice_number)}
                                sx={{
                                  backgroundColor: "rgba(255,255,255,0.15)",
                                  color: "#f8fafc",
                                  borderRadius: "10px",
                                  padding: "8px 14px",
                                  fontWeight: 600,
                                  textTransform: "none",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  border: "1px solid rgba(255,255,255,0.2)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255,255,255,0.22)",
                                    borderColor: "rgba(255,255,255,0.35)",
                                  }
                                }}
                              >
                                <span role="img" aria-label="invoice">📄</span>
                                inv-{payment.invoice_number}
                              </Button>
                              {payment.admission_payment === "no" && (
                                <Button
                                  onClick={() => repeatHandleOpen(paymentrow)}
                                  sx={{
                                    backgroundColor: "#f59e0b",
                                    color: "#0f172a",
                                    borderRadius: "10px",
                                    padding: "8px 14px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#fbbf24",
                                      color: "#0f172a",
                                    }
                                  }}
                                  endIcon={<RepeatIcon />}
                                >
                                  Repeat
                                </Button>
                              )}
                              </Box>
                            </Box>

                          {/* Main Content - gradient data blocks (no white) */}
                          <Box sx={{ p: 2.5, background: "linear-gradient(180deg, rgba(224,231,255,0.5) 0%, rgba(199,210,254,0.4) 100%)" }}>
                            <Grid container spacing={2.5}>
                              {/* Summary row */}
                              <Grid size={{ xs: 12 }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 4,
                                    background: "linear-gradient(135deg, rgba(255,255,255,0.5) 0%, rgba(224,231,255,0.6) 50%, rgba(199,210,254,0.5) 100%)",
                                    borderRadius: "14px",
                                    p: 2.5,
                                    mb: 2,
                                    border: "1px solid rgba(99, 102, 241, 0.2)",
                                    boxShadow: "0 2px 12px rgba(79, 70, 229, 0.12)",
                                  }}
                                >
                                  <Box>
                                    <Typography sx={{ color: "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                      Joining Date
                                    </Typography>
                                    <Typography sx={{ color: "#1e1b4b", fontSize: "1.1rem", fontWeight: 700 }}>
                                      {joiningdateadd}
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography sx={{ color: "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                      Paid Amount
                                    </Typography>
                                    <Typography sx={{ color: "#047857", fontSize: "1.1rem", fontWeight: 700 }}>
                                      ₹{payment.paying_amount}
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography sx={{ color: "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                      Due Amount
                                    </Typography>
                                    <Typography sx={{ color: payment.due > 0 ? "#b91c1c" : "#047857", fontSize: "1.1rem", fontWeight: 700 }}>
                                      ₹{payment.due}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>

                              {/* Payment details row */}
                              <Grid size={{ xs: 12 }}>
                                <Box
                                  sx={{
                                    background: "linear-gradient(135deg, rgba(255,255,255,0.45) 0%, rgba(224,231,255,0.55) 50%, rgba(199,210,254,0.45) 100%)",
                                    borderRadius: "14px",
                                    p: 2.5,
                                    border: "1px solid rgba(99, 102, 241, 0.2)",
                                    boxShadow: "0 2px 12px rgba(79, 70, 229, 0.12)",
                                  }}
                                >
                                  <Grid container spacing={4}>
                                    <Grid size={{ xs: 4 }}>
                                      <Typography sx={{ color: "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                        Member Package
                                      </Typography>
                                      <Typography sx={{ color: "#1e1b4b", fontSize: "1rem", fontWeight: 600 }}>
                                        {payment.member_package != null && String(payment.member_package).trim() !== ""
                                          ? payment.member_package
                                          : "—"}
                                      </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 4 }}>
                                      <Typography sx={{ color: "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                        Payment Date
                                      </Typography>
                                      <Typography sx={{ color: "#1e1b4b", fontSize: "1rem", fontWeight: 600 }}>
                                        {payment.date_of_payment}
                                      </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 4 }}>
                                      <Typography sx={{ color: payment.expired === "Yes" ? "#dc2626" : "#3730a3", fontSize: "0.8rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                                        Expire Date
                                      </Typography>
                                      <Typography sx={{ color: payment.expired === "Yes" ? "#dc2626" : "#1e1b4b", fontSize: "1rem", fontWeight: 600 }}>
                                        {payment.end_date}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Grid>
                            </Grid>

                            {/* Action row */}
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 2,
                                mt: 2.5,
                                pt: 2,
                                borderTop: "1px solid rgba(99, 102, 241, 0.25)",
                              }}
                            >
                              <Box sx={{ display: 'flex', gap: 1.5, flexWrap: "wrap" }}>
                                <Button
                                  onClick={() => handlePayment({
                                    paymentData: {
                                      name: fetchdatarow.name,
                                      member_id: fetchdatarow.id,
                                      email: fetchdatarow.email,
                                      phone: fetchdatarow.phone,
                                      due: payment.due,
                                      payment_id: payment.id,
                                    },
                                  })}
                                  sx={{
                                    backgroundColor: "#0f172a",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    padding: "9px 18px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.25)",
                                    "&:hover": {
                                      backgroundColor: "#1e293b",
                                      boxShadow: "0 4px 12px rgba(15, 23, 42, 0.3)",
                                    }
                                  }}
                                  endIcon={<PaymentIcon />}
                                >
                                  Due Payment
                                </Button>
                                <Button
                                  onClick={() => handleOpenChangeModal(payment)}
                                  sx={{
                                    backgroundColor: "#4f46e5",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    padding: "9px 18px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    boxShadow: "0 2px 8px rgba(79, 70, 229, 0.3)",
                                    "&:hover": {
                                      backgroundColor: "#4338ca",
                                      boxShadow: "0 4px 12px rgba(79, 70, 229, 0.4)",
                                    }
                                  }}
                                  endIcon={<ChangeCircleIcon />}
                                >
                                  Change
                                </Button>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  backgroundColor: payment.expired === "Yes" ? "rgba(239, 68, 68, 0.08)" : "rgba(5, 150, 105, 0.08)",
                                  borderRadius: "12px",
                                  padding: "8px 14px",
                                  border: `1px solid ${payment.expired === "Yes" ? "rgba(239, 68, 68, 0.25)" : "rgba(5, 150, 105, 0.25)"}`,
                                }}
                              >
                                <HourglassBottomIcon sx={{ fontSize: "1.1rem", color: payment.expired === "Yes" ? "#dc2626" : "#059669" }} />
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: payment.expired === "Yes" ? "#dc2626" : "#059669" }}>
                                  {payment.expired === "Yes" ? `Expired - ${payment.expired_days} days ago` : `${payment.days_left} days left`}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                          </Card>
                        </Grid>
                    ))}
                </Grid>

                <Grid container spacing={2}>
               <Grid size={{ xs: 12, md: 6 }} sx={{ minWidth: { xs: "100%", md: 360 } }}>
                    <Card
                      sx={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        overflow: "hidden",
                        background: "linear-gradient(165deg, #e0e7ff 0%, #c7d2fe 35%, #a5b4fc 100%)",
                        border: "1px solid rgba(99, 102, 241, 0.25)",
                        borderRadius: "20px",
                        boxShadow: "0 4px 24px rgba(79, 70, 229, 0.15), 0 1px 3px rgba(0,0,0,0.06)",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        "&:hover": {
                          boxShadow: "0 12px 40px rgba(79, 70, 229, 0.2), 0 4px 12px rgba(0,0,0,0.08)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {ptpaymentrow.length > 0 ? (
                        ptpaymentrow.map((payment, index) => (
                          <React.Fragment key={payment.id != null ? payment.id : index}>
                            {/* Single combined header: Trainer Package (PT) + PT Payment + invoice */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: 2,
                                px: 2.5,
                                py: 2,
                                background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 50%, ${appColors.leaf} 100%)`,
                                color: "#fff",
                                borderBottom: "1px solid rgba(255,255,255,0.12)",
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                                <FitnessCenterIcon sx={{ fontSize: 28, opacity: 0.95, flexShrink: 0 }} />
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography sx={{ fontWeight: 700, fontSize: "1.15rem", letterSpacing: "0.02em", lineHeight: 1.25 }}>
                                    Trainer Package (PT)
                                  </Typography>
                                  <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, opacity: 0.92, mt: 0.25, letterSpacing: "0.04em" }}>
                                    PT Payment
                                  </Typography>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  gap: 1.25,
                                  justifyContent: "flex-end",
                                  flexShrink: 0,
                                }}
                              >
                                <Button
                                  size="small"
                                  variant="contained"
                                  startIcon={<AddIcon sx={{ fontSize: "1.1rem !important" }} />}
                                  onClick={() => openAddPTPModal(payment)}
                                  sx={{
                                    bgcolor: "rgba(255,255,255,0.95)",
                                    color: appColors.evergreen,
                                    fontWeight: 700,
                                    textTransform: "none",
                                    borderRadius: "10px",
                                    px: 1.75,
                                    py: 0.75,
                                    boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                                    "&:hover": { bgcolor: "#fff", color: appColors.pine },
                                  }}
                                >
                                  Payment
                                </Button>
                                {payment.invoice_number != null && (
                                  <Button
                                    onClick={() => handleNavigate(payment.invoice_number)}
                                    sx={{
                                      backgroundColor: "rgba(255,255,255,0.18)",
                                      color: "#fff",
                                      borderRadius: "10px",
                                      padding: "8px 14px",
                                      fontWeight: 600,
                                      textTransform: "none",
                                      border: "1px solid rgba(255,255,255,0.35)",
                                      flexShrink: 0,
                                      "&:hover": { backgroundColor: "rgba(255,255,255,0.28)" },
                                    }}
                                  >
                                    📄 inv-{payment.invoice_number}
                                  </Button>
                                )}
                              </Box>
                            </Box>
             
          {/* Main Content - PT Package & Payment details from pt_data */}
          <Box sx={{ p: 2.5, background: "linear-gradient(180deg, rgba(224,231,255,0.5) 0%, rgba(199,210,254,0.4) 100%)" }}>
            <Grid container spacing={2.5}>
              {/* Trainer & Package - single row */}
              <Grid size={{ xs: 12 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 4,
                    background: "linear-gradient(135deg, rgba(255,255,255,0.6) 0%, rgba(224,231,255,0.5) 50%, rgba(199,210,254,0.4) 100%)",
                    borderRadius: "14px",
                    p: 2.5,
                    border: "1px solid rgba(31, 122, 84, 0.2)",
                    boxShadow: "0 2px 12px rgba(31, 122, 84, 0.1)",
                  }}
                >
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Trainer Name
                    </Typography>
                    <Typography sx={{ color: "#1e293b", fontSize: "1.05rem", fontWeight: 600 }}>
                      {payment.trainer_name || "N/A"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Package
                    </Typography>
                    <Typography sx={{ color: "#1e293b", fontSize: "1.05rem", fontWeight: 600 }}>
                      {payment.trainer_package || "N/A"}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                    <AccessTimeIcon sx={{ color: "#4f46e5", fontSize: 22, mt: 0.25 }} />
                    <Box>
                      <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                        Session slot
                      </Typography>
                      <Typography
                        sx={{
                          color: "#1e293b",
                          fontSize: "1.05rem",
                          fontWeight: 700,
                          fontVariantNumeric: "tabular-nums",
                          letterSpacing: "0.02em",
                        }}
                      >
                        {(() => {
                          const raw = payment.pt_slot_time ?? payment.slot;
                          if (raw == null || String(raw).trim() === "" || String(raw).trim() === "-") {
                            return "N/A";
                          }
                          return String(raw).trim();
                        })()}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Payment row: Date, Payable, Paid, Due */}
              <Grid size={{ xs: 12 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 4,
                    background: "linear-gradient(135deg, rgba(255,255,255,0.6) 0%, rgba(224,231,255,0.5) 50%, rgba(199,210,254,0.4) 100%)",
                    borderRadius: "14px",
                    p: 2.5,
                    border: "1px solid rgba(31, 122, 84, 0.2)",
                    boxShadow: "0 2px 12px rgba(31, 122, 84, 0.1)",
                  }}
                >
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Date of Payment
                    </Typography>
                    <Typography sx={{ color: "#1e293b", fontSize: "1rem" }}>
                      {payment.date_of_payment || "N/A"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Payable
                    </Typography>
                    <Typography sx={{ color: "#1e293b", fontSize: "1rem", fontWeight: 600 }}>
                      ₹{payment.payble_amount != null ? payment.payble_amount : payment.total_payble_amount != null ? payment.total_payble_amount : "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Paid Amount
                    </Typography>
                    <Typography sx={{ color: "#059669", fontSize: "1rem", fontWeight: 600 }}>
                      ₹{payment.paying_amount != null ? payment.paying_amount : "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      Due
                    </Typography>
                    <Typography sx={{ color: payment.due > 0 ? "#dc2626" : "#059669", fontSize: "1rem", fontWeight: 600 }}>
                      ₹{payment.due != null ? payment.due : "0"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Dates & Status */}
              <Grid size={{ xs: 12 }}>
                <Box
                  sx={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: "1px solid rgba(15, 23, 42, 0.06)",
                    boxShadow: "0 2px 16px rgba(15, 23, 42, 0.06)",
                    background: "#fff",
                  }}
                >
                  <Box sx={{ px: 2.25, py: 1.5, background: "linear-gradient(90deg, rgba(31,122,84,0.06) 0%, transparent 100%)", borderBottom: "1px solid rgba(15,23,42,0.06)" }}>
                    <Chip
                      size="small"
                      icon={payment.expired === "Yes" ? <HourglassBottomIcon sx={{ fontSize: "16px !important" }} /> : <CheckCircleIcon sx={{ fontSize: "16px !important" }} />}
                      label={payment.expired === "Yes" ? "Expired" : "Active"}
                      sx={{
                        fontWeight: 700,
                        bgcolor: payment.expired === "Yes" ? "rgba(220, 38, 38, 0.1)" : "rgba(5, 150, 105, 0.12)",
                        color: payment.expired === "Yes" ? "#b91c1c" : "#047857",
                        border: "none",
                      }}
                    />
                  </Box>
                  <Box sx={{ p: 2.25 }}>
                    {/* Timeline */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Typography sx={{ fontSize: "0.65rem", fontWeight: 800, color: "#64748b", letterSpacing: "0.12em", mb: 0.75 }}>
                          START
                        </Typography>
                        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f172a" }}>
                          {payment.start_date || "N/A"}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: "0 0 auto", display: "flex", alignItems: "center", px: 0.5 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: appColors.evergreen }} />
                        <Box sx={{ width: 36, height: 2, background: `linear-gradient(90deg, ${appColors.evergreen}, #c9a227)` }} />
                        <RenewIcon sx={{ fontSize: 18, color: "#c9a227" }} />
                        <Box sx={{ width: 36, height: 2, background: `linear-gradient(90deg, #c9a227, ${appColors.evergreen})` }} />
                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: appColors.evergreen }} />
                      </Box>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Typography sx={{ fontSize: "0.65rem", fontWeight: 800, color: payment.expired === "Yes" ? "#dc2626" : "#64748b", letterSpacing: "0.12em", mb: 0.75 }}>
                          EXPIRE
                        </Typography>
                        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700, color: payment.expired === "Yes" ? "#dc2626" : "#0f172a" }}>
                          {payment.end_date || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    {payment.expired !== "Yes" && payment.days_left != null && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          py: 1.25,
                          px: 2,
                          borderRadius: "12px",
                          background: "linear-gradient(135deg, rgba(5,150,105,0.08) 0%, rgba(5,150,105,0.04) 100%)",
                          border: "1px solid rgba(5, 150, 105, 0.2)",
                        }}
                      >
                        <HourglassBottomIcon sx={{ color: "#059669", fontSize: 22 }} />
                        <Typography sx={{ fontWeight: 700, color: "#047857", fontSize: "0.95rem" }}>
                          {payment.days_left} days remaining on this pass
                        </Typography>
                      </Box>
                    )}
                    {payment.expired === "Yes" && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          py: 1.25,
                          px: 2,
                          borderRadius: "12px",
                          background: "rgba(220, 38, 38, 0.06)",
                          border: "1px solid rgba(220, 38, 38, 0.2)",
                        }}
                      >
                        <HourglassBottomIcon sx={{ color: "#b91c1c", fontSize: 22 }} />
                        <Typography sx={{ fontWeight: 700, color: "#b91c1c", fontSize: "0.95rem" }}>
                          Expired - {payment.expired_days || 0} days ago
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>
              {payment.remarks && (
                <Grid size={{ xs: 12 }}>
                  <Box sx={{ background: "rgba(255,255,255,0.5)", borderRadius: "12px", p: 2, border: "1px solid rgba(31, 122, 84, 0.15)" }}>
                    <Typography sx={{ color: "#3730a3", fontSize: "0.75rem", fontWeight: 600, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>Remarks</Typography>
                    <Typography sx={{ color: "#1e293b", fontSize: "1rem" }}>{payment.remarks}</Typography>
                  </Box>
                </Grid>
              )}
                              </Grid>
                              
            {/* PT actions — grid, equal width, consistent style */}
            <Box
              sx={{
                mt: 2.5,
                pt: 2.5,
                borderTop: "1px solid rgba(31, 122, 84, 0.12)",
                background: "rgba(255,255,255,0.35)",
                borderRadius: "12px",
                px: 1.5,
                pb: 1.5,
              }}
            >
              <Typography sx={{ color: "#3730a3", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", mb: 1.5, px: 0.5 }}>
                Actions
              </Typography>
              <Grid container spacing={1.5}>
                {payment.due > 0 && (
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<PaymentIcon sx={{ fontSize: "1.15rem !important" }} />}
                      onClick={() => handleClickOpendue(payment)}
                      sx={{
                        minHeight: 44,
                        borderRadius: "10px",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        bgcolor: "#dc2626",
                        boxShadow: "none",
                        "&:hover": { bgcolor: "#b91c1c", boxShadow: "0 2px 8px rgba(220,38,38,0.35)" },
                      }}
                    >
                      Clear due
                    </Button>
                  </Grid>
                )}
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<PersonIcon sx={{ fontSize: "1.15rem !important" }} />}
                    onClick={() => handleOpentrainerDialog(payment.id)}
                    sx={{
                      minHeight: 44,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.875rem",
                      bgcolor: appColors.evergreen,
                      boxShadow: "none",
                      "&:hover": { bgcolor: appColors.pine, boxShadow: "0 2px 8px rgba(31,122,84,0.25)" },
                    }}
                  >
                    Change trainer
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<ChangeCircleIcon sx={{ fontSize: "1.15rem !important" }} />}
                    onClick={() => handleOpenChangeModalPt(payment)}
                    sx={{
                      minHeight: 44,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.875rem",
                      bgcolor: appColors.evergreen,
                      boxShadow: "none",
                      "&:hover": { bgcolor: appColors.pine, boxShadow: "0 2px 8px rgba(31,122,84,0.25)" },
                    }}
                  >
                    Change package
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <DuePaymentModal
            open={opendue}
            onClose={handleClosedue}
            onSubmit={(formData) => {
              if (selectedPayment) {
                // date_of_payment must come from modal (calendar) — never overwrite with selectedPayment.date_of_payment (stale / wrong format)
                handleDuePayment({
                  ...formData,
                  member_id: selectedPayment.member_id,
                  payment_id:
                    selectedPayment.payment_id ?? selectedPayment.id,
                });
              }
            }}
            dueAmount={selectedPayment ? selectedPayment.due : 0}
            memberId={selectedPayment ? selectedPayment.member_id : 0}
            paymentId={selectedPayment ? selectedPayment.payment_id : 0}
          />
                          </React.Fragment>
                        ))
                      ) : (
                      <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 2.5,
          py: 2,
          background: `linear-gradient(135deg, ${appColors.evergreen} 0%, ${appColors.leaf} 50%, ${appColors.leaf} 100%)`,
          color: "#fff",
        }}
      >
        <FitnessCenterIcon sx={{ fontSize: 28, opacity: 0.95 }} />
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: "1.15rem", letterSpacing: "0.02em", lineHeight: 1.25 }}>
            Trainer Package (PT)
          </Typography>
          <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, opacity: 0.92, mt: 0.25 }}>
            PT Payment
          </Typography>
        </Box>
      </Box>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        px: 3,
        textAlign: "center",
        backgroundColor: "#f8fafc",
        borderRadius: "0 0 16px 16px",
        minHeight: 200,
      }}>
        <FitnessCenterIcon sx={{ fontSize: 48, color: "#94a3b8", mb: 1.5, opacity: 0.8 }} />
        <Typography variant="h6" sx={{ color: "#334155", fontWeight: 600, mb: 0.5, fontSize: "1.15rem" }}>
          No trainer package assigned
        </Typography>
        <Typography variant="body2" sx={{ color: "#64748b", lineHeight: 1.5, mb: 2, maxWidth: 280 }}>
          Assign a Personal Trainer package to this member.
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={openAddPTPModal}
          sx={{
            backgroundColor: appColors.evergreen,
            color: "#fff",
            borderRadius: "10px",
            px: 3,
            py: 1.5,
            fontWeight: 700,
            textTransform: "none",
            fontSize: "1rem",
            boxShadow: "0 4px 14px rgba(31, 122, 84, 0.4)",
            "&:hover": {
              backgroundColor: appColors.leaf,
              boxShadow: "0 6px 20px rgba(31, 122, 84, 0.45)",
              transform: "scale(1.02)",
            },
          }}
        >
          Add PT 
        </Button>
                      </Box>
                      </>
                      )}
                    </Card>
                  </Grid>

                  {/* Yearly membership — premium card (timeline + status, matches PT visual weight) */}
                  <Grid size={{ xs: 12, md: 6 }} sx={{ minWidth: { xs: "100%", md: 360 }, display: "flex" }}>
                    <Card
                      sx={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "22px",
                        border: "1px solid rgba(15, 23, 42, 0.08)",
                        boxShadow: "0 4px 6px -1px rgba(15, 23, 42, 0.06), 0 20px 50px -12px rgba(31, 122, 84, 0.18)",
                        display: "flex",
                        flexDirection: "column",
                        background: "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)",
                        transition: "box-shadow 0.35s ease, transform 0.25s ease",
                        "&:hover": {
                          boxShadow: "0 8px 12px -2px rgba(15, 23, 42, 0.08), 0 28px 60px -12px rgba(31, 122, 84, 0.22)",
                          transform: "translateY(-3px)",
                        },
                      }}
                    >
                      {/* Premium header — deep navy + gold accent */}
                      <Box
                        sx={{
                          position: "relative",
                          px: 2.75,
                          py: 2.25,
                          background: `linear-gradient(145deg, #0f172a 0%, #1e293b 45%, ${appColors.evergreen} 100%)`,
                          color: "#fff",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: "3px",
                            background: "linear-gradient(90deg, #c9a227 0%, #f4e4bc 35%, #c9a227 70%, #a16207 100%)",
                            opacity: 0.95,
                          },
                        }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 2, pb: 0.5 }}>
                          <Box sx={{ display: "flex", gap: 2, alignItems: "center", minWidth: 0 }}>
                            <Box
                              sx={{
                                width: 48,
                                height: 48,
                                borderRadius: "14px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "linear-gradient(145deg, rgba(201,162,39,0.25) 0%, rgba(255,255,255,0.08) 100%)",
                                border: "1px solid rgba(244,228,188,0.35)",
                              }}
                            >
                              <WorkspacePremiumIcon sx={{ fontSize: 28, color: "#f4e4bc" }} />
                            </Box>
                            <Box>
                              <Typography sx={{ fontWeight: 800, fontSize: "1.2rem", letterSpacing: "-0.02em", lineHeight: 1.2 }}>
                                Yearly membership
                              </Typography>
                              <Typography sx={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.72)", mt: 0.5, fontWeight: 500 }}>
                                Annual access · 12-month cycle
                              </Typography>
                            </Box>
                          </Box>
                          <Button
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={openAddYMPModal}
                            sx={{
                              bgcolor: "rgba(201, 162, 39, 0.92)",
                              color: "#0f172a",
                              fontWeight: 700,
                              textTransform: "none",
                              borderRadius: "10px",
                              px: 1.75,
                              boxShadow: "0 4px 14px rgba(201, 162, 39, 0.35)",
                              "&:hover": { bgcolor: "#e8d48b", color: "#0f172a" },
                            }}
                          >
                            Add yearly
                          </Button>
                        </Box>
                      </Box>

                      <Box sx={{ flex: 1, p: 2.5, display: "flex", flexDirection: "column", minHeight: 280 }}>
                        {yearlymembership && yearlymembership.length > 0 ? (
                          <Stack spacing={2.5} sx={{ flex: 1 }}>
                            {yearlymembership.map((row, idx) => {
                              const endStr = row?.end_date ?? row?.expired_date ?? "";
                              const startStr = row?.start_date ?? "—";
                              const endDisplay = endStr || "—";
                              let daysLeft = null;
                              let expired = false;
                              if (endStr && typeof endStr === "string") {
                                const parts = endStr.split(/[-/]/);
                                if (parts.length === 3) {
                                  const [d, m, y] = parts.map(Number);
                                  const endD = new Date(y, m - 1, d);
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  const diff = Math.ceil((endD - today) / 86400000);
                                  if (diff < 0) expired = true;
                                  else daysLeft = diff;
                                }
                              }
                              return (
                                <Box
                                  key={row?.id ?? idx}
                                  sx={{
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    border: "1px solid rgba(15, 23, 42, 0.06)",
                                    boxShadow: "0 2px 16px rgba(15, 23, 42, 0.06)",
                                    background: "#fff",
                                  }}
                                >
                                  <Box sx={{ px: 2.25, py: 1.5, background: "linear-gradient(90deg, rgba(31,122,84,0.06) 0%, transparent 100%)", borderBottom: "1px solid rgba(15,23,42,0.06)" }}>
                                    <Chip
                                      size="small"
                                      icon={expired ? <HourglassBottomIcon sx={{ fontSize: "16px !important" }} /> : <CheckCircleIcon sx={{ fontSize: "16px !important" }} />}
                                      label={expired ? "Expired" : "Active"}
                                      sx={{
                                        fontWeight: 700,
                                        bgcolor: expired ? "rgba(220, 38, 38, 0.1)" : "rgba(5, 150, 105, 0.12)",
                                        color: expired ? "#b91c1c" : "#047857",
                                        border: "none",
                                      }}
                                    />
                                  </Box>
                                  <Box sx={{ p: 2.25 }}>
                                    {/* Timeline */}
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
                                      <Box sx={{ flex: 1, textAlign: "center" }}>
                                        <Typography sx={{ fontSize: "0.65rem", fontWeight: 800, color: "#64748b", letterSpacing: "0.12em", mb: 0.75 }}>
                                          START
                                        </Typography>
                                        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f172a" }}>{startStr}</Typography>
                                      </Box>
                                      <Box sx={{ flex: "0 0 auto", display: "flex", alignItems: "center", px: 0.5 }}>
                                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: appColors.evergreen }} />
                                        <Box sx={{ width: 36, height: 2, background: `linear-gradient(90deg, ${appColors.evergreen}, #c9a227)` }} />
                                        <RenewIcon sx={{ fontSize: 18, color: "#c9a227" }} />
                                        <Box sx={{ width: 36, height: 2, background: `linear-gradient(90deg, #c9a227, ${appColors.evergreen})` }} />
                                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: appColors.evergreen }} />
                                      </Box>
                                      <Box sx={{ flex: 1, textAlign: "center" }}>
                                        <Typography sx={{ fontSize: "0.65rem", fontWeight: 800, color: "#64748b", letterSpacing: "0.12em", mb: 0.75 }}>
                                          END
                                        </Typography>
                                        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f172a" }}>{endDisplay}</Typography>
                                      </Box>
                                    </Box>
                                    {!expired && daysLeft != null && (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: 1,
                                          py: 1.25,
                                          px: 2,
                                          borderRadius: "12px",
                                          background: "linear-gradient(135deg, rgba(5,150,105,0.08) 0%, rgba(5,150,105,0.04) 100%)",
                                          border: "1px solid rgba(5, 150, 105, 0.2)",
                                        }}
                                      >
                                        <HourglassBottomIcon sx={{ color: "#059669", fontSize: 22 }} />
                                        <Typography sx={{ fontWeight: 700, color: "#047857", fontSize: "0.95rem" }}>
                                          {daysLeft} days remaining on this pass
                                        </Typography>
                                      </Box>
                                    )}
                                    {expired && (
                                      <Typography sx={{ textAlign: "center", color: "#b91c1c", fontWeight: 600, fontSize: "0.875rem" }}>
                                        Renew with Add yearly
                                      </Typography>
                                    )}
                                    {Number(row?.due) > 0 && (
                                      <Box
                                        sx={{
                                          mt: 1.5,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          gap: 1.5,
                                          py: 1,
                                          px: 1.75,
                                          borderRadius: "10px",
                                          background: "rgba(220, 38, 38, 0.06)",
                                          border: "1px solid rgba(220, 38, 38, 0.2)",
                                        }}
                                      >
                                        <Typography sx={{ fontWeight: 700, color: "#b91c1c", fontSize: "0.875rem" }}>
                                          Due: ₹{row.due}
                                        </Typography>
                                        <Button
                                          size="small"
                                          variant="contained"
                                          onClick={() => handleClickOpendueYearly(row)}
                                          sx={{
                                            textTransform: "none",
                                            fontWeight: 700,
                                            borderRadius: "8px",
                                            bgcolor: "#b91c1c",
                                            boxShadow: "none",
                                            "&:hover": { bgcolor: "#991b1b" },
                                          }}
                                        >
                                          Pay Due
                                        </Button>
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })}
                            <Box sx={{ pt: 1, borderTop: "1px solid rgba(15,23,42,0.06)" }}>
                              <Typography sx={{ fontSize: "0.7rem", fontWeight: 800, color: "#94a3b8", letterSpacing: "0.14em", mb: 1.25 }}>
                                ACTIONS
                              </Typography>
                              <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={openAddYMPModal}
                                sx={{
                                  textTransform: "none",
                                  fontWeight: 700,
                                  borderRadius: "12px",
                                  py: 1.25,
                                  borderColor: appColors.evergreen,
                                  color: appColors.evergreen,
                                  borderWidth: 2,
                                  "&:hover": { borderWidth: 2, bgcolor: "rgba(31, 122, 84, 0.04)" },
                                }}
                              >
                                Add another yearly period
                              </Button>
                            </Box>

                            <DuePaymentModal
                              open={opendueYearly}
                              onClose={handleClosedueYearly}
                              onSubmit={(formData) => {
                                if (selectedYearlyPayment) {
                                  handleYearlyDuePayment({
                                    ...formData,
                                    member_id: selectedYearlyPayment.member_id,
                                    payment_id:
                                      selectedYearlyPayment.payment_id ?? selectedYearlyPayment.id,
                                  });
                                }
                              }}
                              dueAmount={selectedYearlyPayment ? selectedYearlyPayment.due : 0}
                              memberId={selectedYearlyPayment ? selectedYearlyPayment.member_id : 0}
                              paymentId={selectedYearlyPayment ? selectedYearlyPayment.payment_id : 0}
                            />
                          </Stack>
                        ) : (
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              py: 3,
                              px: 3,
                              textAlign: "center",
                              borderRadius: "16px",
                              border: "1px dashed rgba(31, 122, 84, 0.2)",
                              background: "linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(241,245,249,0.8) 100%)",
                            }}
                          >
                            <Box
                              sx={{
                                width: 88,
                                height: 88,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 2,
                                background: "linear-gradient(145deg, rgba(31,122,84,0.08) 0%, rgba(201,162,39,0.12) 100%)",
                                border: "2px solid rgba(201, 162, 39, 0.35)",
                                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8)",
                              }}
                            >
                              <WorkspacePremiumIcon sx={{ fontSize: 40, color: appColors.evergreen, opacity: 0.85 }} />
                            </Box>
                            <Typography sx={{ color: "#0f172a", fontWeight: 800, fontSize: "1.15rem", letterSpacing: "-0.02em", mb: 0.75 }}>
                              No annual pass yet
                            </Typography>
                            <Typography sx={{ color: "#64748b", fontSize: "0.875rem", lineHeight: 1.6, mb: 2.5, maxWidth: 260 }}>
                              Lock in 12 months of membership. Amount and dates are set when you add.
                            </Typography>
                            <Button
                              variant="contained"
                              size="large"
                              startIcon={<AddIcon />}
                              onClick={openAddYMPModal}
                              sx={{
                                background: `linear-gradient(145deg, ${appColors.evergreen} 0%, #0f172a 100%)`,
                                color: "#fff",
                                borderRadius: "12px",
                                px: 3.5,
                                py: 1.5,
                                fontWeight: 800,
                                textTransform: "none",
                                boxShadow: "0 8px 24px rgba(31, 122, 84, 0.35)",
                                "&:hover": { background: `linear-gradient(145deg, ${appColors.leaf} 0%, ${appColors.evergreen} 100%)`, boxShadow: "0 12px 28px rgba(31, 122, 84, 0.4)" },
                              }}
                            >
                              Add yearly membership
                            </Button>
                          </Box>
                        )}
                      </Box>
                    </Card>
                  </Grid>

                  {/* Circle: membership expiry — disabled (set to true to show again) */}
                  {false && (
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 6 }}
                  >
                    <style>
                      {`
                        @keyframes fadeIn {
                          from { opacity: 0; }
                          to { opacity: 1; }
                        }
                        @keyframes slideIn {
                          from { transform: translateY(20px); opacity: 0; }
                          to { transform: translateY(0); opacity: 1; }
                        }
                      `}
                    </style>
                    <Card
                      sx={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        background: "linear-gradient(135deg, #3a1c71, #d76d77, #ffaf7b)",
                        borderRadius: "50%",
                        width: "300px",
                        height: "300px",
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        transition: "transform 0.4s, box-shadow 0.4s, opacity 1s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: "0 15px 40px rgba(0, 0, 0, 0.3)",
                        },
                        opacity: 0,
                        animation: "fadeIn 2s forwards",
                      }}
                    >
                      {yearlymembership && yearlymembership.length > 0 ? (
                        yearlymembership.map((payment, index) => {
                          if (!payment?.end_date || typeof payment.end_date !== "string") return null;
                          const [day, month, year] = payment.end_date.split("-");
                          const endDate = new Date(`${year}-${month}-${day}`);
                          const today = new Date();
                          const isExpired = endDate < today;
                          return (
                            <React.Fragment key={index}>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "20px",
                                  animation: "slideIn 1s ease-out",
                                  animationDelay: "0.5s",
                                }}
                              >
                                {isExpired ? (
                                  <>
                                    Membership expired on:
                                    <br />
                                    <span style={{ color: "red" }}>{payment.end_date}</span>
                                  </>
                                ) : (
                                  <>
                                    Membership will expire in:
                                    <br />
                                    <span style={{ color: "#90ee90" }}>{payment.end_date}</span>
                                  </>
                                )}
                              </Typography>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <Typography
                          variant="h6"
                          sx={{
                            color: "white",
                            fontSize: "14px",
                            animation: "slideIn 1s ease-out",
                            animationDelay: "0.5s",
                          }}
                        >
                          No Membership Data Available
                        </Typography>
                      )}
                    </Card>
                  </Grid>
                  )}

                </Grid>
              </div>
            </div>
          </div>
        )}
      </Box>
      <Dialog open={isPauseModal} onClose={closePauseModal} maxWidth="sm" fullWidth>
        <StyledDialogTitle>
          Pause Membership
          <CloseButton edge="end" onClick={closePauseModal} aria-label="close">
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>
        <DialogContent sx={{ width: "500px" }}>
          <Typography> Are you sure you want to pause your Package?</Typography>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ marginTop: "13px", marginRight: "10px" }}>
              From Date :{" "}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
              <DatePicker
                value={selectedDate} // Pass the selected date to the DatePicker component
                onChange={handleDateChange} // Call handleDateChange when date is selected
                slotProps={{ textField: { size: "small" } }}
              />
            </LocalizationProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              textTransform: "none",
              whiteSpace: "nowrap",
              fontWeight: 700,
            }}
            onClick={closePauseModal}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "none",
              whiteSpace: "nowrap",
              fontWeight: 700,
            }}
            onClick={handleClickPause}
          >
            Pause
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isResumeModal} onClose={closeResumeModal} maxWidth="sm" fullWidth>
        <StyledDialogTitle>
          Resume Membership
          <CloseButton edge="end" onClick={closeResumeModal} aria-label="close">
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>
        <DialogContent sx={{ width: "500px" }}>
          <Typography>Are you sure you want to resume your package?</Typography>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ marginTop: "13px", marginRight: "10px" }}>
              Resume Date :{" "}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
           
                <DatePicker
                  value={resumeDate}
                  onChange={(date) => setResumeDate(date)}
                  slotProps={{ textField: { size: "small" } }}
                />
             
            </LocalizationProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeResumeModal} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClickResume} disabled={!resumeDate}>
            {/* Add loading indicator if needed */}
            Resume
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isAddPTPModal}
        onClose={closeAddPTPModal}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(15, 23, 42, 0.5)" } },
        }}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "800px",
          },
        }}
      >
        <StyledDialogTitle>
          Add Personal Trainer Package
          <CloseButton edge="end" onClick={closeAddPTPModal} aria-label="close">
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>
        <DialogContent sx={{ minWidth: "800px" }}>
          
            <Grid
              container
              spacing={3}
              sx={{ marginTop: "10px", marginBottom: "5px", mt:3, paddingX: "20px" }}
            >
              <Grid  size={{ xs: 4}}>
                <Grid   size={{ xs: 12}}>
                  <TextField
                    label="Name"
                    disabled
                    value={fetchdatarow.name}
                    fullWidth
                    placeholder=" Enter Name"
                  />
                </Grid>
              </Grid>
              {/* Second Row */}
              <Grid   size={{ xs: 4}}>
                <Grid container spacing={3}>
                  <Grid  size={{ xs: 12}}>
                    <TextField
                      label="Phone"
                      disabled
                      value={fetchdatarow.phone}
                      fullWidth
                      placeholder=" Enter Phone"
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item xs={4}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField label="Paying Amount" fullWidth placeholder="Enter Paying Amount..." />
                                    </Grid>
                                </Grid>
                            </Grid> */}
              <Grid size={{ xs: 4}}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12}}>
                    <FormControl  fullWidth>
                      <InputLabel id="demo-simple-select-helper-label">
                        Choose Trainer Package
                      </InputLabel>
                      <Select
                        fullWidth
                     
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="Choose Trainer Package"
                        value={FormData.package}
                        error={submitted && !FormData.package} // Check for error
                        helperText={submitted && !FormData.package  &&
                          "Trainer  is required"} // Display error message
                        onChange={handlepayblevalueChange}
                      >
                   
                        {Dropdowndata.map((row) => (
                          <MenuItem value={row.id}>{row.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

           
            
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{ marginTop: "10px", marginBottom: "5px", paddingX: "20px" }}
            >
              <Grid size={{ xs: 4}}>
                <Grid size={{ xs: 12}}>
                  <TextField
                    label="Package Value"
                    fullWidth
                    placeholder=" Enter Package Value"
                    inputProps={{ readOnly: true }}
                    value={FormData.packagevalue}
                    error={submitted && !FormData.packagevalue} // Check for error
                    
                    helperText={submitted && !FormData.packagevalue &&
                      "Package Value is required"} // Display error message
                  
                    onChange={(e) =>
                      setFormData({ ...FormData, packagevalue: e.target.value })
                    }
                  />
                </Grid>
              </Grid>
              <Grid size={{ xs: 4}}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12}}>
                    <TextField
                      label="Payble Amount"
                      type="number"
                      fullWidth
                      placeholder=" Enter Payble amount"
                      value={FormData.totalpaybleamount}
                      inputProps={{ readOnly: true }}
                      InputLabelProps={{ shrink: !!FormData.totalpaybleamount }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 4}}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12}}>
                    <TextField
                      label="Discount"
                      fullWidth
                      type="number"
                      placeholder="Enter Discount"
                      value={FormData.discount}

                      onChange={(e) => handleDiscountChange(e)} // Call the function when discount changes
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{ marginTop: "10px", marginBottom: "5px", paddingX: "20px" }}
            >
              <Grid size={{ xs: 4}}>
                <Grid size={{ xs: 12}}>
                  <TextField
                    label="Paying Amount"
                    fullWidth
                    value={FormData.payingamount}
                    error={submitted && !FormData.payingamount} // Check for error
                    helperText={submitted && !FormData.payingamount &&
                      "Paying Amount is required"} // Display error message
                  
                    onChange={(e) =>
                      setFormData({ ...FormData, payingamount: e.target.value })
                    }
                  />
                </Grid>
              </Grid>
              {/* Second Row */}
              <Grid size={{ xs: 4}}>
              <Grid container spacing={2}>
                  <Grid size={{ xs: 12}}>
                    <FormControl  fullWidth error={submitted && !FormData.modeofpayment}>
                      <InputLabel id="demo-simple-select-helper-label">
                        Mode of Payment
                      </InputLabel>
                      <Select
                        fullWidth
                     
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="Mode of Payment"
                        value={FormData.modeofpayment}
                        onChange={(e) =>
                          setFormData({
                            ...FormData,
                            modeofpayment: e.target.value,
                          })
                        }
                      >
                        {/* <MenuItem value="">
                      <em>Select Payment Type</em>
                    </MenuItem> */}
                        <MenuItem value="paytm">Paytm</MenuItem>
                        <MenuItem value="googlepay">Google Pay</MenuItem>
                        <MenuItem value="phonepe">PhonePe</MenuItem>
                        <MenuItem value="cash">Cash</MenuItem>
                        <MenuItem value="card"> Card</MenuItem>
                        {submitted && !FormData.modeofpayment && (
        <FormHelperText>This field is required</FormHelperText>
      )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 4}}>
                <Grid size={{ xs: 12}}>
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoItem components={["DatePicker"]}>
                        <DatePicker
                          value={FormData.dateofpayment}
                          onChange={(date) =>
                            setFormData({ ...FormData, dateofpayment: date })
                          } // Update 'dob' state in formData
                          label="Date of Payment"
                          format="DD/MM/YYYY"
                          clearable
                          slotProps={{
                            textField: {
                              error: submitted && !FormData.dateofpayment,
                              helperText:
                                submitted &&
                                !FormData.dateofpayment &&
                                "Date of Payment is required",
                            },
                          }}
                        />
               </DemoItem>
                    </LocalizationProvider>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              sx={{ marginTop: "20px", marginBottom: "12px", paddingX: "20px" }}
            >
              <Grid size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.primary" }}>
                  Trainer, session, and times
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                  Select trainer, then <strong>Morning</strong> or <strong>Evening</strong>. Start and end times only allow that session window.
                </Typography>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Box>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoItem components={["DatePicker"]}>
                          <DatePicker
                            value={FormData.activationdate}
                            onChange={(date) =>
                              setFormData({
                                ...FormData,
                                activationdate: date,
                              })
                            }
                            label="Activation Date"
                            format="DD/MM/YYYY"
                            clearable
                            slotProps={{
                              textField: {
                                error: submitted && !FormData.activationdate,
                                helperText:
                                  submitted &&
                                  !FormData.activationdate &&
                                  "Activation Date is required",
                              },
                            }}
                          />
                        </DemoItem>
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <FormControl fullWidth>
                  <InputLabel id="add-pt-trainer-label">Choose Trainer</InputLabel>
                  <Select
                    fullWidth
                    labelId="add-pt-trainer-label"
                    id="add-pt-trainer"
                    label="Choose Trainer"
                    value={FormData.trainer}
                    error={submitted && !FormData.trainer}
                    onChange={(e) =>
                      setFormData({
                        ...FormData,
                        trainer: e.target.value,
                        ptSession: "",
                        startTime: null,
                        endTime: null,
                      })
                    }
                  >
                    <MenuItem value="">
                      <em>Select Trainer</em>
                    </MenuItem>
                    {Dropdowndatatrainer.map((row) => (
                      <MenuItem key={row.id} value={row.id}>
                        {row.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {submitted && !FormData.trainer && (
                    <FormHelperText error>Trainer is required</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <FormControl
                  fullWidth
                  disabled={
                    !FormData.trainer ||
                    ptTrainerSlotLoading ||
                    !(
                      ptTrainerSlotInfo &&
                      (hasTrainerMorningSlot(ptTrainerSlotInfo) ||
                        hasTrainerEveningSlot(ptTrainerSlotInfo))
                    )
                  }
                  error={
                    submitted &&
                    !!FormData.trainer &&
                    !FormData.ptSession &&
                    !!ptTrainerSlotInfo &&
                    (hasTrainerMorningSlot(ptTrainerSlotInfo) ||
                      hasTrainerEveningSlot(ptTrainerSlotInfo)) &&
                    !ptTrainerSlotLoading
                  }
                >
                  <InputLabel id="add-pt-session-label">Morning or Evening</InputLabel>
                  <Select
                    labelId="add-pt-session-label"
                    id="add-pt-session"
                    label="Morning or Evening"
                    value={FormData.ptSession}
                    onChange={(e) =>
                      setFormData({
                        ...FormData,
                        ptSession: e.target.value,
                        startTime: null,
                        endTime: null,
                      })
                    }
                  >
                    <MenuItem value="">
                      <em>Select session</em>
                    </MenuItem>
                    {hasTrainerMorningSlot(ptTrainerSlotInfo) ? (
                      <MenuItem value="morning">Morning</MenuItem>
                    ) : null}
                    {hasTrainerEveningSlot(ptTrainerSlotInfo) ? (
                      <MenuItem value="evening">Evening</MenuItem>
                    ) : null}
                  </Select>
                  {FormData.trainer && ptTrainerSlotLoading && (
                    <FormHelperText>Loading schedule…</FormHelperText>
                  )}
                  {submitted &&
                    FormData.trainer &&
                    !FormData.ptSession &&
                    ptTrainerSlotInfo &&
                    (hasTrainerMorningSlot(ptTrainerSlotInfo) ||
                      hasTrainerEveningSlot(ptTrainerSlotInfo)) &&
                    !ptTrainerSlotLoading && (
                    <FormHelperText error>Required — pick morning or evening</FormHelperText>
                  )}
                  {ptTrainerSlotInfo &&
                    FormData.trainer &&
                    !ptTrainerSlotLoading &&
                    hasTrainerMorningSlot(ptTrainerSlotInfo) &&
                    !hasTrainerEveningSlot(ptTrainerSlotInfo) && (
                    <FormHelperText>
                      {rawEveningSlotPresent(ptTrainerSlotInfo)
                        ? "Evening exists on the server but could not be read. Use a range like 5:00 PM - 8:00 PM or 17:00 - 20:00."
                        : "Evening is not listed because this trainer has no evening hours from the server (empty evening_slot)."}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              sx={{ marginTop: "4px", marginBottom: "20px", paddingX: "20px" }}
            >
              <Grid size={{ xs: 4 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Start Time"
                    disabled={!ptTimeBounds || ptTrainerSlotLoading}
                    minTime={ptTimeBounds?.slotStart}
                    maxTime={ptTimeBounds?.maxStart}
                    value={FormData.startTime ? dayjs(FormData.startTime) : null}
                    onChange={(newValue) => {
                      setFormData((prev) => {
                        const next = { ...prev, startTime: newValue };
                        if (newValue && prev.endTime) {
                          const st = dayjs(newValue);
                          const et = dayjs(prev.endTime);
                          if (st.isValid() && et.isValid() && !et.isAfter(st)) {
                            next.endTime = null;
                          }
                        }
                        return next;
                      });
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: { bgcolor: "background.paper" },
                        error:
                          (submitted && !FormData.startTime) ||
                          (submitted &&
                            !!ptTimeBounds &&
                            !!FormData.startTime &&
                            !isPtStartTimeWithinSessionSlot(
                              dayjs(FormData.startTime),
                              ptTrainerSlotInfo,
                              FormData.ptSession
                            )),
                        helperText: (() => {
                          if (submitted && !FormData.startTime) return "Start time is required";
                          if (!FormData.ptSession && FormData.trainer && ptTrainerSlotInfo) {
                            return "Choose Morning or Evening first.";
                          }
                          if (FormData.ptSession && ptTrainerSlotInfo) {
                            return trainerSlotAllowedStartSummaryForSession(
                              ptTrainerSlotInfo,
                              FormData.ptSession
                            );
                          }
                          return "";
                        })(),
                      },
                      popper: { sx: { zIndex: 2000 } },
                      desktopPaper: { sx: { bgcolor: "background.paper" } },
                      mobilePaper: { sx: { bgcolor: "background.paper" } },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="End Time"
                    disabled={!ptTimeBounds || ptTrainerSlotLoading || !FormData.startTime}
                    minTime={ptEndPickerMinTime ?? undefined}
                    maxTime={ptTimeBounds?.slotEnd}
                    value={FormData.endTime ? dayjs(FormData.endTime) : null}
                    onChange={(newValue) =>
                      setFormData({ ...FormData, endTime: newValue })
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: { bgcolor: "background.paper" },
                        error:
                          (submitted && !FormData.endTime) ||
                          (submitted &&
                            !!ptTimeBounds &&
                            !!FormData.endTime &&
                            !isPtEndTimeWithinSessionSlot(
                              dayjs(FormData.endTime),
                              ptTrainerSlotInfo,
                              FormData.ptSession
                            )),
                        helperText: (() => {
                          if (submitted && !FormData.endTime) return "End time is required";
                          if (!FormData.startTime && FormData.ptSession) {
                            return "Pick start time first.";
                          }
                          return "";
                        })(),
                      },
                      popper: { sx: { zIndex: 2000 } },
                      desktopPaper: { sx: { bgcolor: "background.paper" } },
                      mobilePaper: { sx: { bgcolor: "background.paper" } },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid> 
        
        </DialogContent>
        <DialogActions>
          <Button
             sx={{ fontWeight: "bold", textTransform: "none" }}   variant="outlined"   startIcon={<CancelIcon />}
            onClick={closeAddPTPModal}
            color="primary"
          >
            Cancel
          </Button>
          {/* <Button color="primary" onClick={handleDelete}>
                                        Apply
                                    </Button> */}
          <Button
             variant="contained"
             sx={{ fontWeight: "bold", textTransform: "none" }}
            startIcon={addPTPSubmitting ? <CircularProgress size={18} color="inherit" /> : <CheckCircleIcon />}
            onClick={handleClickAddPTP}
            disabled={addPTPSubmitting}
          >
            Payment
          </Button>
        </DialogActions>
      </Dialog>
      {/* Are you sure? - Add PT */}
      <Dialog open={confirmAddPTPOpen} onClose={() => setConfirmAddPTPOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to add PT to payment?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmAddPTPOpen(false)} color="primary" variant="outlined">Cancel</Button>
          <Button onClick={doAddPTP} color="primary" variant="contained" startIcon={<CheckCircleIcon />} disabled={addPTPSubmitting}>Yes, proceed</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isAddYMPModal}
        onClose={closeAddYMPModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 24px 48px rgba(15, 23, 42, 0.18)",
          },
        }}
      >
        <StyledDialogTitle sx={{ py: 2 }}>
          Add yearly membership
          <CloseButton edge="end" onClick={closeAddYMPModal} aria-label="close">
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>

        <DialogContent sx={{ pt: 2, pb: 1, px: 3 }}>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2, lineHeight: 1.5 }}>
            Packages load from <strong>admission-value/dropdown</strong>. Choosing a package calls <strong>admission-value/get/value</strong> (same as New Member) to fill amount.
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2.25}>
              <TextField
                label="Member"
                value={fetchdatarow?.name ?? ""}
                fullWidth
                size="small"
                InputProps={{ readOnly: true }}
                sx={{ "& .MuiOutlinedInput-root": { bgcolor: "action.hover", borderRadius: "10px" } }}
              />
              <FormControl fullWidth size="small" required>
                <InputLabel id="ymp-admission">Admission / package</InputLabel>
                <Select
                  labelId="ymp-admission"
                  label="Admission / package"
                  value={ympAdmissionValueId}
                  onChange={handleYmpAdmissionChange}
                  disabled={ympLoadingPackageValue}
                  sx={{ borderRadius: "10px" }}
                >
                  {Dropdownadmissiondata.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.name ?? row.admission_value ?? `ID ${row.id}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Package amount (₹)"
                type="number"
                value={ympPackageAmount}
                onChange={(e) => setYmpPackageAmount(e.target.value)}
                fullWidth
                size="small"
                inputProps={{ min: 0, step: 1 }}
                placeholder="Select package above or type amount"
                helperText={ympLoadingPackageValue ? "Loading amount…" : "From admission-value/get/value — you can edit"}
                InputProps={{
                  endAdornment: ympLoadingPackageValue ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null,
                }}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                required
              />
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2.25}>
                <TextField
                  label="Offer / discount (₹)"
                  type="number"
                  value={ympOffer}
                  onChange={(e) => setYmpOffer(e.target.value)}
                  fullWidth
                  size="small"
                  inputProps={{ min: 0, step: 1 }}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                />
                <TextField
                  label="Paying amount (₹)"
                  type="number"
                  value={ympPayingAmount}
                  onChange={(e) => setYmpPayingAmount(e.target.value)}
                  fullWidth
                  size="small"
                  inputProps={{ min: 0, step: 1 }}
                  helperText="Package amount − offer — edit for a partial payment"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                />
              </Stack>
              {ympDue > 0 && (
                <Typography variant="body2" sx={{ color: "warning.main", fontWeight: 600, mt: -1 }}>
                  Due after this payment: ₹{ympDue}
                </Typography>
              )}
              <FormControl fullWidth size="small">
                <InputLabel id="ymp-payment-mode">Payment mode</InputLabel>
                <Select
                  labelId="ymp-payment-mode"
                  label="Payment mode"
                  value={ympPaymentMode}
                  onChange={(e) => setYmpPaymentMode(e.target.value)}
                  sx={{ borderRadius: "10px" }}
                >
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="googlepay">Google Pay</MenuItem>
                  <MenuItem value="phonepe">PhonePe</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                  <MenuItem value="card">Card</MenuItem>
                  <MenuItem value="bank_transfer">Bank transfer</MenuItem>
                </Select>
              </FormControl>
              <DatePicker
                value={startDate ? dayjs(startDate) : null}
                onChange={(d) => handleStartDateChange(d ? d.toDate() : null)}
                label="Start date"
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    helperText: "Required — sent as YYYY-MM-DD",
                    sx: { "& .MuiOutlinedInput-root": { borderRadius: "10px" } },
                  },
                }}
              />
              <TextField
                label="End date (reference)"
                value={
                  startDate ? dayjs(startDate).add(365, "day").format("DD/MM/YYYY") : ""
                }
                fullWidth
                size="small"
                InputProps={{ readOnly: true }}
                sx={{ "& .MuiOutlinedInput-root": { bgcolor: "action.hover", borderRadius: "10px" } }}
                helperText="Typical yearly window (backend may set final end date)"
              />
            </Stack>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            gap: 1.5,
            borderTop: "1px solid",
            borderColor: "divider",
            bgcolor: "grey.50",
          }}
        >
          <Button
            onClick={closeAddYMPModal}
            variant="outlined"
            startIcon={<CancelIcon />}
            disabled={ympSubmitting}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px", minWidth: 100 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={ympSubmitting ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
            onClick={handleClickAddYMP}
            disabled={!startDate || !ympAdmissionValueId || !ympPackageAmount || ympSubmitting}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              minWidth: 120,
              boxShadow: "none",
              "&:hover": { boxShadow: "0 4px 14px rgba(31, 122, 84, 0.35)" },
            }}
          >
            {ympSubmitting ? "Adding…" : "Add yearly package"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={useopen}
        onClose={handlerenwalclose}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(15, 23, 42, 0.5)" } },
        }}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "800px",
          },
        }}
      >
        <StyledDialogTitle>
          Renew Package
          <CloseButton edge="end" onClick={handlerenwalclose} aria-label="close">
            <CloseIcon />
          </CloseButton>
        </StyledDialogTitle>
        <DialogContent sx={{ minWidth: "800px", px: 4, py: 3 }}>
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 800, color: appColors.evergreen, letterSpacing: "0.08em", mb: 2.5 }}>
            MAIN PACKAGE
          </Typography>
          <Grid container spacing={3} sx={{ mb: 3.5 }}>
            <Grid size={{ xs: 6 }}>
              <FormControl fullWidth>
                <InputLabel id="package-label">Package</InputLabel>
                <Select
                  labelId="package-label"
                  id="package"
                  label="Package"
                  value={formdueData.package_id}
                  onChange={handlepayblevalueChangemember}
                  fullWidth
                >
                  {Dropdowndatamember.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>Choose the plan being renewed</FormHelperText>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                label="Total Payable Amount"
                fullWidth
                name="total_payble_amount"
                value={formdueData.total_payble_amount}
                onChange={handleChangerenwal}
                InputLabelProps={{ shrink: true }}
                helperText="Full price of the selected package"
              />
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                type="number"
                label="Payable Amount"
                fullWidth
                name="payble_amount"
                value={formdueData.payble_amount}
                onChange={handleChangerenwal}
                InputLabelProps={{ shrink: true }}
                helperText="Amount owed after any adjustments"
              />
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                label="Offer"
                fullWidth
                name="offer"
                value={formdueData.offer}
                onChange={handleChangerenwal}
                InputLabelProps={{ shrink: true }}
                helperText="Discount applied to this renewal"
              />
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                type="number"
                label="Paying Amount"
                fullWidth
                name="paying_amount"
                value={formdueData.paying_amount}
                onChange={handleChangerenwal}
                InputLabelProps={{ shrink: true }}
                helperText="Amount being collected today"
              />
            </Grid>

            <Grid size={{ xs: 6 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-helper-label">
                  Mode of Payment
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Mode of Payment"
                  value={formdueData.mode_of_payment}
                  name="mode_of_payment"  // Add name attribute to identify the field
                  onChange={handleChangePaymentMode}
                >
                  <MenuItem value="paytm">Paytm</MenuItem>
                  <MenuItem value="googlepay">Google Pay</MenuItem>
                  <MenuItem value="phonepe">PhonePe</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="card"> Card</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                label="Date of Payment"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formdueData.date_of_payment || ""}
                onChange={(e) =>
                  setFormdueData((prev) => ({
                    ...prev,
                    date_of_payment: e.target.value,
                  }))
                }
              />
            </Grid>

            <Grid size={{ xs: 6 }}>
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: getMinStartDate()
                    ? dayjs(getMinStartDate(), "DD-MM-YYYY").format("YYYY-MM-DD")
                    : undefined,
                }}
                value={formdueData.start_date || ""}
                onChange={(e) => {
                  const newStartDate = e.target.value;
                  setFormdueData((prev) => {
                    const selectedPackage = Dropdowndatamember.find((row) => row.id === prev.package_id);
                    const computedEndDate = selectedPackage?.duration && newStartDate
                      ? dayjs(newStartDate).add(Number(selectedPackage.duration), "day").format("YYYY-MM-DD")
                      : prev.end_date_preview;
                    return {
                      ...prev,
                      start_date: newStartDate,
                      end_date_preview: computedEndDate,
                    };
                  });
                }}
                sx={{
                  "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
                    backgroundColor: "#e2e8f0",
                  },
                }}
              />
              {formdueData.end_date_preview && (
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: appColors.evergreen, mt: 0.75 }}>
                  Expire: {dayjs(formdueData.end_date_preview).format("DD/MM/YYYY")}
                </Typography>
              )}
            </Grid>
          </Grid>

          {membershipExpired && (
            <Box
              sx={{
                border: "1px solid rgba(201, 162, 39, 0.35)",
                background: "rgba(201, 162, 39, 0.05)",
                borderRadius: "12px",
                p: 3,
              }}
            >
              <Typography sx={{ fontSize: "0.75rem", fontWeight: 800, color: "#a8801f", letterSpacing: "0.08em", mb: 0.5 }}>
                YEARLY MEMBERSHIP
              </Typography>
              <Typography sx={{ fontSize: "0.8rem", color: "#8a6d1f", mb: 2.5 }}>
                Renewed as its own separate payment, with its own due if left unpaid.
              </Typography>

              <Grid container spacing={3}>
                <Grid size={{ xs: 6 }}>
                  <FormControl fullWidth>
                    <InputLabel id="membership-label">Membership</InputLabel>
                    <Select
                      labelId="membership-label"
                      id="membership"
                      label="Membership"
                      value={formdueData.membership}
                      onChange={handlepayblevalueadmissionrepeat}
                      placeholder="Choose Membership"
                      fullWidth
                    >
                      {Dropdownadmissiondata.map((row) => (
                        <MenuItem key={row.id} value={row.id}>
                          {row.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>Yearly plan to renew</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 6 }}>
                  <TextField
                    id="membership-value"
                    label="Payable Amount"
                    inputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={formdueData.yearly_payble_amount}
                    helperText="Full price of the yearly membership"
                  />
                </Grid>

                <Grid size={{ xs: 6 }}>
                  <TextField
                    type="number"
                    label="Offer"
                    fullWidth
                    value={formdueData.yearly_offer}
                    onChange={handleYearlyOfferChange}
                    InputLabelProps={{ shrink: true }}
                    helperText="Discount on the yearly fee"
                  />
                </Grid>

                <Grid size={{ xs: 6 }}>
                  <TextField
                    type="number"
                    label="Paying Amount"
                    fullWidth
                    value={formdueData.yearly_paying_amount}
                    onChange={handleYearlyPayingAmountChange}
                    InputLabelProps={{ shrink: true }}
                    helperText="Edit for a partial payment — the rest becomes due"
                  />
                </Grid>

                {(() => {
                  const yearlyDue = Math.max(
                    0,
                    (parseFloat(formdueData.yearly_payble_amount) || 0) -
                      (parseFloat(formdueData.yearly_offer) || 0) -
                      (parseFloat(formdueData.yearly_paying_amount) || 0)
                  );
                  return yearlyDue > 0 ? (
                    <Grid size={{ xs: 12 }}>
                      <Typography sx={{ color: "#b91c1c", fontWeight: 700, fontSize: "0.9rem" }}>
                        Yearly due after this payment: ₹{yearlyDue}
                      </Typography>
                    </Grid>
                  ) : null;
                })()}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 3 }}>
          <StyledButton onClick={handlerenwalclose} variant="outlined">
            Cancel
          </StyledButton>
          <StyledButton
            onClick={handleSave}
            variant="contained"
            disabled={renwalloading}
          >
            {renwalloading ? <CircularProgress size={24} /> : "Payment"}
          </StyledButton>
        </DialogActions>
      </Dialog>
      {/* Are you sure? - Renew Package */}
      <Dialog open={confirmRenewOpen} onClose={() => setConfirmRenewOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to renew the package?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmRenewOpen(false)} color="primary" variant="outlined">Cancel</Button>
          <Button onClick={doRenewSave} color="primary" variant="contained" startIcon={<CheckCircleIcon />} disabled={renwalloading}>Yes, proceed</Button>
        </DialogActions>
      </Dialog>
      <DetailDialog
        open={dialogOpen}
        handleClose={handleCloseDialog}
        data={fetchdatarow}
      />
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      <Dialog
        open={repeatOpen}
        onClose={repeatHandleClose}
        aria-labelledby="repeat-package-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="repeat-package-dialog">
          Repeat Package for Member
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            Enter offer details:
          </Typography>

          {repeatEndDatePreview && (
            <Typography sx={{ fontSize: 14, fontWeight: 600, color: appColors.evergreen, mb: 2 }}>
              Expire: {repeatEndDatePreview}
            </Typography>
          )}

          <TextField
            fullWidth
            label="Offer"
            type="number"
            value={repeatOffer}
            onChange={(e) => setRepeatOffer(e.target.value)}
            sx={{ marginBottom: 2 }}
          />

          <FormControl sx={{ minWidth: 120 }} fullWidth>
            <InputLabel id="demo-simple-select-helper-label">
              Mode of Payment
            </InputLabel>
            <Select
              fullWidth
              sx={{ minWidth: 120, height: "50px" }}
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              label="Mode of Payment"
              value={repeatModeOfPayment}
              onChange={(e) => setRepeatModeOfPayment(e.target.value)}
            >
              {/* <MenuItem value="">
                      <em>Select Payment Type</em>
                    </MenuItem> */}
              <MenuItem value="paytm">Paytm</MenuItem>
              <MenuItem value="googlepay">Google Pay</MenuItem>
              <MenuItem value="phonepe">PhonePe</MenuItem>
              <MenuItem value="cash">Cash</MenuItem>
              <MenuItem value="card"> Card</MenuItem>
            </Select>
          </FormControl>

          {membershipExpired && (
      <>
          <FormControl fullWidth   sx={{ marginTop: 2 }}>
        <InputLabel id="membership-label">Membership</InputLabel>
        <Select
          labelId="membership-label"
          id="membership-label"
          label="Membership"
          value={renewalType}
          onChange={handlepayblevalueadmissionChange}
          placeholder="Choose Membership"
          fullWidth
         
        >
          {Dropdownadmissiondata.map((row) => (
            <MenuItem key={row.id} value={row.id}>
              {row.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  <TextField
        type="number"
         label="Renewal Amount"
        inputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={renewalAmount}
        sx={{ marginTop: 2 }}
        onChange={(e) => setRenewalAmount(e.target.value)}
      />
     
      </>
    )}
        </DialogContent>

        <DialogActions>
          <StyledButton onClick={repeatHandleClose} variant="outlined">
            Cancel
          </StyledButton>
          <StyledButton
            onClick={handleRepeatClick}
            variant="contained"
            disabled={!repeatOffer || !repeatModeOfPayment || (membershipExpired && (!renewalType || !renewalAmount))}
          >
            {renwalloading ? <CircularProgress size={24} /> : "Payment"}
          </StyledButton>
        </DialogActions>
      </Dialog>
      {/* Are you sure? - Repeat Package */}
      <Dialog open={confirmRepeatOpen} onClose={() => setConfirmRepeatOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to repeat the package?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmRepeatOpen(false)} color="primary" variant="outlined">Cancel</Button>
          <Button onClick={handleRepeatPackage} color="primary" variant="contained" startIcon={<CheckCircleIcon />} disabled={renwalloading}>Yes, proceed</Button>
        </DialogActions>
      </Dialog>

      <ChangePackage
        open={openChangeModal}
        onClose={handleCloseChangeModal}
        packageData={selectedPaymentData}
        member_id={conversation_id}
        fetchData={fetchData}
      />
       <ChangePackagePt
         open={openChangeModalpt}
         onClose={handleCloseChangeModalpt}
        packageData={selectedPaymentDataPt}
        member_id={conversation_id}
        fetchData={fetchData}
      />
       <Dialog
  maxWidth="sm"
  fullWidth
  open={isChangeTrainerDialogOpen}
  onClose={handleClosetrainerDialog}
  aria-labelledby="change-trainer-dialog-title"
>
  <StyledDialogTitle id="change-trainer-dialog-title">Change Trainer</StyledDialogTitle>
  <DialogContent>
    {/* Single Dropdown */}
    <FormControl fullWidth sx={{ marginTop: "10px" }}>
      <InputLabel id="demo-simple-select-helper-label">Choose Trainer</InputLabel>
      <Select
        fullWidth
        sx={{ minWidth: 120, height: "55px" }}
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={trainer}
        label="Choose Trainer"
        onChange={(e) => setTrainer(e.target.value)} 
      >
        <MenuItem value="">
          <em>Select Trainer</em>
        </MenuItem>
        {Dropdowndatatrainer.map((row) => (
          <MenuItem key={row.id} value={row.id}>
            {row.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </DialogContent>
  <DialogActions>
    <StyledButton        variant="outlined"
            sx={{ fontWeight: "bold", textTransform: "none" }}     startIcon={<CancelIcon />} onClick={handleClosetrainerDialog} color="primary">
      Cancel
    </StyledButton>
    <StyledButton
       variant="contained"
       sx={{ fontWeight: "bold", textTransform: "none" }}
      onClick={() => {
        if (!trainer) return;
        setConfirmChangeTrainerOpen(true);
      }}
      startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <CheckCircleIcon />}
      disabled={loading}
      color="primary"
    >
      Change PT to Payment
    </StyledButton>
  </DialogActions>
</Dialog>

      {/* Are you sure? - Change Trainer */}
      <Dialog open={confirmChangeTrainerOpen} onClose={() => setConfirmChangeTrainerOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to change the trainer?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmChangeTrainerOpen(false)} color="primary" variant="outlined">Cancel</Button>
          <Button
            onClick={() => {
              setConfirmChangeTrainerOpen(false);
              handleTrainerChangeapi();
            }}
            color="primary"
            variant="contained"
            startIcon={<CheckCircleIcon />}
            disabled={loading}
          >
            Yes, change trainer
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
    
  );
}

export default MemberDetails;